import { AfterViewInit, Component, Input, OnInit, ViewChild } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { MapService } from "../_services/map/map.service";
import { CableDetails } from "../_models/cable-details";
import { Series } from "../_models/series";
import { Config } from "../config";
import * as Highcharts from "highcharts";
import { HighchartsChartComponent } from "highcharts-angular";
import { GMonData } from "../_models/gmon-data";
import { GridElement } from "../_models/grid-element";
import { ApplicationService } from "../_services/application/application.service";
import { NumberUtils } from "../_commons/number-utils";
import { LoadingAnalysisData } from "../_models/loading-analysis-data";
import { Cable } from "../_models/cable";
import { isNotNullOrUndefined } from "codelyzer/util/isNotNullOrUndefined";
import { ConfigurationService } from "../_services/configuration/configuration.service";
import { TranslateService } from "@ngx-translate/core";
import { GridColor } from "../_models/grid-color";
import { Condition } from "../_models/condition";
import { GMonService } from "../_services/gmon-service/gmon.service";
import { GPlanService } from "../_services/gplan-service/gplan.service";
import { LaService } from "../_services/la-service/la.service";
import { CableColor } from "../_models/cable-color";
import { DateUtils } from "../_commons/date-utils";
import { ReactivePowerAnalysisService } from "../_services/reactive-power-analysis-service/reactive-power-analysis.service";
import { ViolationResults } from "../_models/violation-results";
import { ReactivePowerAnalysis } from "../_models/reactive-power-analysis";
import { UIUtils } from "../_commons/ui-utils";
import { GPlanInput } from "../_models/gplan-input";
import { error } from "@angular/compiler/src/util";
import { FormControl, FormGroup } from "@angular/forms";
import { LmService } from "../_services/lm-service/lm.service";
import { ShortCircuitCurrentAnalysisService } from "../_services/short-circuit-current-analysis-service/short-circuit-current-analysis.service";
import { ScccData } from "../_models/sccc-data";
import { TopologyList } from "../_models/topology-list";
import { element } from "protractor";
import { min } from "rxjs-compat/operator/min";
import { CommunicationService } from '../_services/communication-service/communication.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { create } from "domain";

@Component({
  selector: "app-cable-details-dialog",
  templateUrl: "./cable-details-dialog.component.html",
  styleUrls: ["./cable-details-dialog.component.css"],
})
export class CableDetailsDialogComponent implements OnInit, AfterViewInit {

  Highcharts: typeof Highcharts = Highcharts;
  @Input() public gridElementId: number;
  @Input() public nodesMap: Map<number, GridElement> = new Map<number,GridElement>();
  @Input() public cablesMap: Map<number, Cable> = new Map<number, Cable>();
  @Input() public selectedPlanningScenario: boolean;
  @Input() public selectedScenarioName: string;
  @Input() public selectedScenarioId: number;
  @Input() public selectedScenario: GPlanInput;
  @Input() public showPlanningWindowIsOpen: boolean;
  @Input() public jumpTopology: string;

  public cableData: Array<any> = new Array<any>();
  public cableType = "";

  @ViewChild("gmonTimeViewChart", { static: false })
  public gmonTimeViewChart?: HighchartsChartComponent;

  @ViewChild("cableLoadingChart", { static: false })
  public cableLoadingChart?: HighchartsChartComponent;

  @ViewChild("gplanCableLoadingChart", { static: false })
  public gplanCableLoadingChart?: HighchartsChartComponent;

  @ViewChild("feederViewCablesChart", { static: false })
  public feederViewCablesChart?: HighchartsChartComponent;

  @ViewChild("feederViewNodesChart", { static: false })
  public feederViewNodesChart?: HighchartsChartComponent;

  @ViewChild("feederViewRpaChart", { static: false })
  public feederViewRpaChart?: HighchartsChartComponent;

  @ViewChild("scccOutputViewChart", { static: false})
  public scccOutputViewChart?: HighchartsChartComponent;

  public cablePosition: string = "";
  public cableSourceNode: string = "";
  public cableEndNode: string = "";
  public isFeederChartEmpty: boolean = false;
  public areGMonQuantilesPresent: boolean = true;
  //public isCurrentTab: boolean = false;
  public isGMonTimeChartEmpty: boolean = false;
  gmonAvailable: boolean = false;
  laAvailable: boolean = false;
  gplanAvailable: boolean = false;
  rpaAvailable: boolean = false;
  lmResultVisualizationInterval:number = 5;
  lmResultsRefreshPeriodInSeconds:number = 180;
  gmonDataAvailable = false;
  laDataAvailable = false;
  gplanDataAvailable = false;
  rpaDataAvailable = false;

  gmonTimeViewOptions: Highcharts.Options;
  cableLoadingOptions: Highcharts.Options;
  feederViewCablesOptions: Highcharts.Options;
  feederViewNodesOptions: Highcharts.Options;
  gplanCableLoadingOptions: Highcharts.Options;
  feederViewRpaOptions: Highcharts.Options;
  scccOutputViewOptions: Highcharts.Options;

  translations: any;
  labelAverage: string = "";

  labelWorstCaseFeederVoltage: string = "";
  labelAveragePlanning: string = "";
  labelViolations: string = "";
  labelViolationsPlanning: string = "";

  labelLoad: string = "";
  labelPlanningLoad: string = "";
  labelWorstCaseLoad: string = "";
  labelMinLowerQuantile: string = "";
  labelMaxUpperQuantile: string = "";
  labelMinLowerQuantilePlanning: string = "";
  labelMaxUpperQuantilePlanning: string = "";
  labelAverageLoad: string = "";
  labelAverageLoadPlanning: string = "";
  labelNoInductiveViolations: string = "";
  labelNoCapacitiveViolations: string = "";
  labelInductiveViolations: string = "";
  labelCapacitiveViolations: string = "";
  labelMaxLoad: string = "";
  labelLoadWorstCase: string = "";
  labelNormalScenario: string = "";
  labelPlanningScenario: string = "";

  labelMaxLoadPlanning: string = "";


  isDangerFeederLACable: boolean = false;
  isAttentionFeederLACable: boolean = false;
  isDangerFeederLANode: boolean = false;
  isDangerFeederRPANode: boolean = false;
  isAttentionFeederLANode: boolean = false;
  isAttentionFeederRPANode: boolean = false;
  isDangerLACable: boolean = false;
  isDangerLACableGP: boolean = false;

  //Feeder Trafo Loads
  isDangerFeederTrafoLoads: boolean = false;
  isAttentionFeederTrafoLoads: boolean = false;

  //Feeder Trafo Loads - For Planning
  isDangerFeederTrafoLoadsGP: boolean = false;
  isAttentionFeederTrafoLoadsGP: boolean = false;

  //Feeder Voltage
  isDangerFeederGMon: boolean = false;
  isAttentionFeederGMon: boolean = false;

  //Feeder Voltage - For Planning
  isDangerFeederGMonGP: boolean = false;
  isAttentionFeederGMonGP: boolean = false;

  public isInputFieldForLiveMonitoringComponentShown: boolean = false;

  isAttentionLACable: boolean = false;
  isAttentionLACableGP: boolean = false;
  gridElementIdNodes: Array<number> = new Array<number>();
  gridElementIdcables: Array<number> = new Array<number>();
  public worstCase: boolean = false;

  intervalVariable;

  timestampArray: Array<any> = new Array<any>();
  value: Array<number> = new Array<number>();

  livePowerDataOptions: any;

  private isSccaAnalysisAvailable: boolean = false;
  private scenariosMap: Map<number, string> = new Map<number,string>();
  public forecastLaDataMap: Array<string> = new Array<string>();
  public forecastLaPlanningDataMap: Array<string> = new Array<string>();

  updateCableLoadingTimeViewFlag = false;
  updateGmonTimeViewChartFlag = false;
  updateFeederViewCablesChartFlag = false;
  updateFeederViewNodesChartFlag = false;
  updateFeederViewRpaChartFlag = false;
  private chart?: Highcharts.Chart;

  chartCallBack = (chart: Highcharts.Chart ) => { this.chart = chart }

  constructor(
    private spinner: NgxSpinnerService,
    public activeModal: NgbActiveModal,
    private mapService: MapService,
    private applicationService: ApplicationService,
    public translateService: TranslateService,
    private gMonService: GMonService,
    private gPlanService: GPlanService,
    private laService: LaService,
    private rpaService: ReactivePowerAnalysisService,
    private configurationService: ConfigurationService,
    private lmService: LmService,
    private snackBar: MatSnackBar,
    private shortCircuitCurrentAnalysisService: ShortCircuitCurrentAnalysisService,
    private communicationService: CommunicationService
  ) {
    const applications: any = this.configurationService.getConfiguration().APPLICATIONS;
    this.gmonAvailable = applications.gmonAvailable;
    this.laAvailable = applications.laAvailable;
    this.gplanAvailable = applications.gplanAvailable;
    this.rpaAvailable = applications.rpaAvailable;
    this.lmResultVisualizationInterval = this.configurationService.getConfiguration().lmResultVisualizationInterval;
    this.lmResultsRefreshPeriodInSeconds = this.configurationService.getConfiguration().lmResultsRefreshPeriodInSeconds;

    this.isInputFieldForLiveMonitoringComponentShown = this.configurationService.getConfiguration().APPLICATIONS.configurationForInputFieldInLiveMonitoringComponent;

    this.initDataAvailableParameters();

    this.scccOutputViewOptions = {
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "column",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        },
        styledMode: true,
      },
      title:{
        text: "",
      },
      series: [],
      xAxis: {
        labels:{
          enabled: false
        },
        categories: [],
        title: {
          text: "",
        }
      },
      yAxis: [
        {
          min: 0,
          // Removed scaleBreaks as it is not a valid property
          title: {
            text: "",
          }
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: "",
          },
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        series: {
          stickyTracking: true,
        },
      },
      tooltip: {
        useHTML: true,
        formatter: function () {
          // return Config.getChartTooltipScccChart(this)
          const point = this.point;
          const seriesName = this.series.name;
          const yValue = this.y;
          const valueSuffix = "A"

          return `<div style = color: #333; background-color: #f9f9f9; padding:10px; border-radius: 5px;">
              <strong>${seriesName}</strong><br>
              <span>Value: <strong>${yValue} ${valueSuffix}</strong></span>
            </div>`;
        }
      },
      credits: {
        enabled: false,
      },
    }

    this.gmonTimeViewOptions = {
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "column",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      title: {
        text: "",
      },
      series: [],
      xAxis: {
        categories: [],
        title: {
          text: "",
        },
      },
      yAxis: [
        {
          min: 0,
          // Removed scaleBreaks as it is not a valid property

          title: {
            text: "",
          },
          plotLines: [
            {
              color: "#FF0000",  //red
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
            {
              color: "#FF0000",  // red
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
          ],
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: "",
          },
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        series: {
          stickyTracking: true,
        },
      },
      credits: {
        enabled: false,
      },
    };

    this.cableLoadingOptions = {
      title: {
        text: "",
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "line",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      xAxis: {
        labels: {
          formatter: function () {
            return this.value.toString();
          }
        },
        categories: [],
        title: {
          text: "",
        },
      },
      yAxis: [
        {
          min: 0,
          title: {
            text: "",
          },

          // scaleBreaks: {
          //   autoCalculate: true,
          // },

          endOnTick: true,
          plotLines: [
            {
              color: "#FF0000",
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
          ],
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false,
      },
    };

    this.gplanCableLoadingOptions = {
      title: {
        text: "",
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "line",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: "",
        },
      },
      yAxis: [
        {
          min: 0,
          title: {
            text: "",
          },

          // scaleBreaks: {
          //   autoCalculate: true,
          // },

          endOnTick: true,
          plotLines: [
            {
              color: "#FF0000",
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
          ],
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false,
      },
    };

    this.feederViewCablesOptions = {
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "column",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      title: {
        text: "",
      },
      series: [],
      xAxis: {
        categories: [],
        title: {
          text: "",
        },
      },
      yAxis: [
        {
          min: 0,
          title: {
            text: "",
          },

          // scaleBreaks: {
          //   autoCalculate: true,
          // },

          plotLines: [
            {
              color: "#FF0000",
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
          ],
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: "",
          },
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        series: {
          stickyTracking: true,
          // whiskerWidth: 5,
        },
      },
      credits: {
        enabled: false,
      },
    };

    this.feederViewNodesOptions = {
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "column",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      title: {
        text: "",
      },
      series: [],
      xAxis: {
        categories: [],
        title: {
          text: "",
        },
      },
      yAxis: [
        {
          min: 0,
          title: {
            text: "",
          },

          // scaleBreaks: {
          //   autoCalculate: true,
          // },

          plotLines: [
            {
              color: "#FF0000",
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
          ],
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: "",
          },
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        series: {
          stickyTracking: true,
          // whiskerWidth: 5,
        },
      },
      credits: {
        enabled: false,
      },
    };

    this.feederViewRpaOptions = {
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "column",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      title: {
        text: "",
      },
      series: [],
      xAxis: {
        categories: [],
        title: {
          text: "",
        },
      },
      yAxis: [
        {
          min: 0,
          title: {
            text: "",
          },

          // scaleBreaks: {
          //   autoCalculate: true,
          // },

          plotLines: [
            /*{
              color: "#FF0000",
              width: 1,
              dashStyle: "shortdash",
              value: 0,
              zIndex: 3
            },*/
          ],
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: "",
          },
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        series: {
          stickyTracking: true,
          // whiskerWidth: 5,
        },
      },
      credits: {
        enabled: false,
      },
    };

    // Translations
    const language = localStorage.getItem("Language");

    translateService.getTranslation(language).subscribe((translations) => {
      console.log("Translations: ", translations);

      this.translations = translations;

      this.cableLoadingOptions.title.text = translations["code-string"]["Cable-Loading"];
      if(!Array.isArray(this.cableLoadingOptions.xAxis)){
        this.cableLoadingOptions.xAxis.title.text = translations["code-string"]["Time-intervals"];
      }
      this.cableLoadingOptions.yAxis[0].title.text = translations["code-string"]["Loading-percent-Current"];

      this.gmonTimeViewOptions.title.text = translations["code-string"]["Feeder-Voltage"];
      if(!Array.isArray(this.gmonTimeViewOptions.xAxis)){
        this.gmonTimeViewOptions.xAxis.title.text = translations["code-string"]["Grid-nodes"];
      }
      this.gmonTimeViewOptions.yAxis[0].title.text = translations["code-string"].Voltages;
      this.gmonTimeViewOptions.yAxis[1].title.text = translations["code-string"].Violations;

      //Short circuit current tab -> text on the graph
      // this.scccOutputViewOptions.title.text = translations["short-circuit-current-calculations"]["1eeaa911-adb8-4190-916d-784654a631a3"];
      // this.scccOutputViewOptions.xAxis.title.text = "xAxisText [NEED TO TRANSLATE]";
      // this.scccOutputViewOptions.yAxis[0].title.text = translations["short-circuit-current-calculations"]["ecda9546-aa16-40dd-acf4-4bbd367907d6"];
      // this.scccOutputViewOptions.yAxis[1].title.text = "yAxisText Secondary[NEED TO TRANSLATE]";
      this.labelNormalScenario = translations["short-circuit-current-calculations"]["cce1eaae-7363-4ac2-97d2-4d1608c93a92"];
      this.labelPlanningScenario = translations["short-circuit-current-calculations"]["156856bf-6509-46c7-812a-e398b82e8d52"];

      if (this.selectedScenario && this.selectedScenario.type == "WC") {
        this.gplanCableLoadingOptions.title.text = translations["code-string"]["Cable-Loading-Worst-Case"];
      } else {
        this.gplanCableLoadingOptions.title.text = translations["code-string"]["Cable-Loading-Pre-and-Post-planning"];
      }

      if(!Array.isArray(this.gplanCableLoadingOptions.xAxis)){
        this.gplanCableLoadingOptions.xAxis.title.text = translations["code-string"]["Time-intervals"];
      }
      this.gplanCableLoadingOptions.yAxis[0].title.text = translations["code-string"]["Loading-percent-Current"];

      this.feederViewCablesOptions.title.text = translations["code-string"]["Feeder-View-Cables"];
      if(!Array.isArray(this.feederViewCablesOptions.xAxis)){
        this.feederViewCablesOptions.xAxis.title.text = translations["code-string"].Cables;
      }
      this.feederViewCablesOptions.yAxis[0].title.text = translations["code-string"].Load + " (%)";
      this.feederViewCablesOptions.yAxis[1].title.text = translations["code-string"].Violations;

      this.feederViewNodesOptions.title.text = translations["code-string"]["Feeder-View-Nodes"];
      if(!Array.isArray(this.feederViewNodesOptions.xAxis)){
        this.feederViewNodesOptions.xAxis.title.text = translations["code-string"].Nodes;
      }
      this.feederViewNodesOptions.yAxis[0].title.text = translations["code-string"].Load + " (%)";
      this.feederViewNodesOptions.yAxis[1].title.text = translations["code-string"].Violations;

      this.feederViewRpaOptions.title.text = translations["code-string"]["Feeder-View-RPA"];
      if(!Array.isArray(this.feederViewRpaOptions.xAxis)){
        this.feederViewRpaOptions.xAxis.title.text = translations["code-string"].Nodes;
      }
      this.feederViewRpaOptions.yAxis[0].title.text = translations["code-string"].Violations;

      this.labelAverage = translations["code-string"].Average;
      this.labelAveragePlanning = translations["code-string"].AveragePlanning;
      this.labelWorstCaseFeederVoltage = translations["code-string"].WorstCaseFeederVoltage;

      this.labelViolations = translations["code-string"].Violations;
      this.labelViolationsPlanning = translations["code-string"].ViolationsPlanning;

      this.labelLoad = translations["code-string"].Load;
      this.labelPlanningLoad = translations["code-string"]["Planning-Load"];
      this.labelWorstCaseLoad = translations["code-string"]["Worst-Case-Load"];
      this.labelMinLowerQuantile = translations["code-string"]["Min-lower-quantile"];
      this.labelMaxUpperQuantile = translations["code-string"]["Max-upper-quantile"];
      this.labelMinLowerQuantilePlanning = translations["code-string"]["Min-lower-quantile-planning"];
      this.labelMaxUpperQuantilePlanning = translations["code-string"]["Max-upper-quantile-planning"];
      this.labelAverageLoad = translations["code-string"]["Average-load"];
      this.labelAverageLoadPlanning = translations["code-string"]["Average-load-planning"];

      this.labelMaxLoad = translations["code-string"]["Max-load"];
      this.labelLoadWorstCase = translations["code-string"]["Load-Worst-Case"];

      this.labelMaxLoadPlanning = translations["code-string"]["Max-load-planning"];

      this.labelNoCapacitiveViolations = translations["code-string"]["No-capacitive-violations"];
      this.labelNoInductiveViolations = translations["code-string"]["No-inductive-violations"];
      this.labelCapacitiveViolations = translations["code-string"]["capacitive-violations"];
      this.labelInductiveViolations = translations["code-string"]["inductive-violations"];
    });
  }
  ngAfterViewInit(): void {
    const cableLoadingTimeViewTab = document.getElementById('cable-loading-time-view-tab');
    if(cableLoadingTimeViewTab){
      cableLoadingTimeViewTab.addEventListener('shown.bs.tab', () => {
        setTimeout(() => this.chart?.reflow(), 0);
      })
    }
  }

  ngOnInit() {
    this.getGridElementIdNodes();
    //this.isCurrentTab = this.doGPlanRunning();
    console.log('gridid0:  ' + this.gridElementId);
    this.loadCableDetails();
    // this.loadFeederChart();

    console.log("laDataAvailable: " + this.laDataAvailable)
    console.log("laAvailable: " + this.laAvailable)

    console.log("gplanDataAvailable: " + this.gplanDataAvailable)
    console.log("gplanAvailable: " + this.gplanAvailable)

    console.log("gmonDataAvailable: " + this.gmonDataAvailable)
    console.log("gmonAvailable: " + this.gmonAvailable)

    console.log("rpaDataAvailable: " + this.rpaDataAvailable)
    console.log("rpaDataAvailable: " + this.rpaDataAvailable)

    this.checkWorstCase();
    this.isSccaAnalysisAvailable = this.shortCircuitCurrentAnalysisService.getIsSccaAvailable();
    this.getListOfScenarios();
  }

  settingIntervalForChart(){
    this.livePowerDataOptions = {
      chart: {
        width: UIUtils.calculateWidth(window, Config.RPV_CHART_WIDTH_PERCENTAGE),
        type: 'line',
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      title: {
          text: 'Echtzeit Leitungsauslastung'
      },
      xAxis: {
        labels:{
          formatter: function() {
            return this.value;
          }
        },
          categories: []
      },
      yAxis: [
          {
            title: {
              text: " [%]"
            }
          }],
      plotOptions: {
          line: {
              dataLabels: {
                  enabled: false
              },
              enableMouseTracking: true
          }
      },
      series: [
        {
          name: 'Leitungsauslastung',
          data: []
        }
      ],
      credits:{
        enabled: false,
      }
      }

      // console.log("IntervalWorks")
      // this.addValue(Math.round(Math.random()* 100));
      // this.livePowerDataOptions.series[0].data = this.testingData
      // this.livePowerDataOptions.series[0].data.push(Math.random()* 10);
      // this.livePowerDataOptions.series[0].data.push(Math.random()* 10);
      // console.log("PUSHING THIS DATA " + this.livePowerDataOptions.series[0].data)
      // this.livePowerDataChart.options = this.livePowerDataOptions
      // this.livePowerDataChart.redraw;
  }

  loadCableDetails() {

    clearInterval(this.intervalVariable)

    this.mapService
      .getCableDetails(this.gridElementId)
      .subscribe((cableDetailsResult: CableDetails) => {
        // console.log(cableDetails);

        const cableDetails: CableDetails = new CableDetails(
          cableDetailsResult.gridElementId,
          cableDetailsResult.sourceGridElementName,
          cableDetailsResult.endGridElementName,
          cableDetailsResult.length,
          cableDetailsResult.type,
          cableDetailsResult.resistance,
          cableDetailsResult.reactance,
          cableDetailsResult.capacitanceC1uFKm,
          cableDetailsResult.isOverhead,
          cableDetailsResult.isUnderground,
          cableDetailsResult.maxCurrent
        );

        this.cableType = cableDetails.type;

        this.cableData.push({
          attribute: this.translations["code-string"].type,
          value: cableDetails.type,
        });

        this.cablePosition = cableDetails.getPosition();
        if (this.cablePosition) {
          this.cableData.push({
            attribute: this.translations["code-string"].position,
            value: cableDetails.getPosition(),
          });
        }

        this.cableData.push({
          attribute: this.translations["code-string"]["max-current"],
          value: cableDetails.maxCurrent.toFixed(0).toLocaleString() + " A",
        });

        const lengthInMeters: number = cableDetails.length * 1000;
        this.cableData.push({
          attribute: this.translations["code-string"].length,
          value: lengthInMeters.toFixed(0).toLocaleString() + " m",
        });

        this.cableSourceNode = cableDetails.sourceGridElementName;
        this.cableData.push({
          attribute: this.translations["code-string"]["source-node"],
          value: cableDetails.sourceGridElementName,
        });

        this.cableEndNode = cableDetails.endGridElementName;
        this.cableData.push({
          attribute: this.translations["code-string"]["end-node"],
          value: cableDetails.endGridElementName,
        });

        const resistancePerKm: number = cableDetails.resistance;
        const resistance: number = resistancePerKm * (lengthInMeters / 1000);
        this.cableData.push({
          attribute: this.translations["code-string"].resistance,
          value: resistance.toFixed(2).toLocaleString() + " Ω",
        });

        const reactancePerKm: number = cableDetails.reactance;
        const reactance: number = reactancePerKm * (lengthInMeters / 1000);
        this.cableData.push({
          attribute: this.translations["code-string"].reactance,
          value: reactance.toFixed(2).toLocaleString() + " Ω",
        });

        const capacitancePerKm: number = cableDetails.capacitanceC1uFKm;
        const capacitance: number = capacitancePerKm * (lengthInMeters / 1000);
        this.cableData.push({
          attribute: this.translations["code-string"].capacitance,
          value: capacitance.toFixed(2).toLocaleString() + " uF",
        });
      });
  }

  loadFeederChart() {

    clearInterval(this.intervalVariable)
    this.isFeederChartEmpty = false;
    if (this.gridElementIdNodes) {
      this.feederChart(this.gridElementIdNodes);
    } else {
      this.applicationService
        .getFeederNodes(this.gridElementId)
        .subscribe((gridElements: Array<any>) => {
          console.log(JSON.stringify(gridElements));
          const gridElementIds: Array<number> = new Array<number>();
          gridElements.forEach((gridElement: any) => {
            gridElementIds.push(gridElement.id);
          });
          this.feederChart(gridElementIds);
          //  console.log(gridElementIds, gridElementIds);
        });
    }

  }


  private feederChart(gridElementIds: Array<number>) {

    //if user has selected scenario
    if (this.selectedPlanningScenario == true) {
      this.applicationService.getGmonDataFeederViewPlanning(this.selectedScenario.id, gridElementIds).subscribe((gMonOutputDatas: Array<string>) => {
        console.log(gMonOutputDatas);

        const xAxisCategories: Array<string> = new Array<string>();
        const series: Array<Series> = new Array<Series>();
        const tooltipVoltage: any = Config.getChartTooltip("V");

        this.applicationService.getGmonDataFeederViewForPlanning(gridElementIds, this.selectedScenarioId).subscribe((gMonOutputDatasForPlanning: Array<string>) => {
          console.log("gMonOutputDatasForPlanning" + gMonOutputDatasForPlanning);

          if ((!gMonOutputDatas || gMonOutputDatas.length == 0) && (!gMonOutputDatasForPlanning || gMonOutputDatasForPlanning.length == 0)) {
            this.isFeederChartEmpty = true;
            return;
          }

          //////////////////////////////Feeder View Planning Series//////////////////////////////
          if (gMonOutputDatasForPlanning && gMonOutputDatasForPlanning.length > 0) {

            const avgSeriesPlanning: Series = new Series(
              this.labelAveragePlanning,
              new Array<number>()
            );
            avgSeriesPlanning.color = "#0569C3";              //dark blue
            avgSeriesPlanning.tooltip = tooltipVoltage;

            const minLowerQuantileSeriesPlanning: Series = new Series(
              this.labelMinLowerQuantilePlanning,
              new Array<number>()
            );
            minLowerQuantileSeriesPlanning.tooltip = tooltipVoltage;
            minLowerQuantileSeriesPlanning.color = "#26C02D";        //dark green

            const maxUpperQuantileSeriesPlanning: Series = new Series(
              this.labelMaxUpperQuantilePlanning,
              new Array<number>()
            );
            maxUpperQuantileSeriesPlanning.tooltip = tooltipVoltage;
            maxUpperQuantileSeriesPlanning.color = "#26C02D";          //dark green

            const numberOfViolationsSeriesPlanning: Series = new Series(
              this.labelViolationsPlanning,
              new Array<number>()
            );
            numberOfViolationsSeriesPlanning.tooltip = Config.getChartTooltip("");
            numberOfViolationsSeriesPlanning.color = "#96081C";        //dark red


            gMonOutputDatasForPlanning.forEach((gMonOutputDatasForPlanningTmp) => {
              const gMonOutputDataPlanning: GMonData = JSON.parse(gMonOutputDatasForPlanningTmp);

              let maxUpperQuantileTemp = null;
              if (gMonOutputDataPlanning.voltageResult.maxUpperQuantile != null) {
                maxUpperQuantileTemp = parseFloat(
                  NumberUtils.format1(
                    gMonOutputDataPlanning.voltageResult.maxUpperQuantile,
                    2
                  )
                );
                maxUpperQuantileSeriesPlanning.data.push(maxUpperQuantileTemp);
              } else {
                console.log("areGMonQuantilesPresent")
                this.areGMonQuantilesPresent = false;
              }

              let minLowerQuantileTemp = null;
              if (gMonOutputDataPlanning.voltageResult.minLowerQuantile != null) {
                minLowerQuantileTemp = parseFloat(
                  NumberUtils.format1(
                    gMonOutputDataPlanning.voltageResult.minLowerQuantile,
                    2
                  )
                );
                minLowerQuantileSeriesPlanning.data.push(minLowerQuantileTemp);
              }

              let avgAverageTemp = null;
              if (gMonOutputDataPlanning.voltageResult.avgAverage != null) {
                avgAverageTemp = parseFloat(
                  NumberUtils.format1(
                    gMonOutputDataPlanning.voltageResult.avgAverage,
                    2
                  )
                );
                avgSeriesPlanning.data.push(avgAverageTemp);
              }

              let numberOfViolationsTemp = null;

              if (gMonOutputDataPlanning.voltageResult.numberOfViolations != null) {
                numberOfViolationsTemp = parseFloat(
                  NumberUtils.format1(
                    gMonOutputDataPlanning.voltageResult.numberOfViolations,
                    2
                  )
                );
                numberOfViolationsSeriesPlanning.data.push(numberOfViolationsTemp);
              }
              numberOfViolationsSeriesPlanning.yAxis = 1;
            });


            series.push(maxUpperQuantileSeriesPlanning)
            series.push(minLowerQuantileSeriesPlanning)
            series.push(avgSeriesPlanning)
            series.push(numberOfViolationsSeriesPlanning)

            const god: GMonData = JSON.parse(gMonOutputDatasForPlanning[0]);
            this.gmonTimeViewOptions.yAxis[0].plotLines[0].value =
              god.voltageResult.upperViolationLimit;
            this.gmonTimeViewOptions.yAxis[0].plotLines[1].value =
              god.voltageResult.lowerViolationLimit;

            (this.gmonTimeViewOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
            this.gmonTimeViewOptions.series = JSON.parse(
              JSON.stringify(series)
            );

            if (this.gmonTimeViewChart) {
              this.gmonTimeViewChart.options = this.gmonTimeViewOptions;
            }
          }

          /////////////////////////////////////////////////////////////////////////////////////

          if (gMonOutputDatas && gMonOutputDatas.length > 0) {
            const avgSeries: Series = new Series(
              this.labelAverage,
              new Array<number>()
            );
            avgSeries.color = "#85D9FF";         //bright blue
            avgSeries.tooltip = tooltipVoltage;

            const minLowerQuantileSeries: Series = new Series(
              this.labelMinLowerQuantile,
              new Array<number>()
            );
            minLowerQuantileSeries.tooltip = tooltipVoltage;
            minLowerQuantileSeries.color = "#C0FE76";          //bright green

            const maxUpperQuantileSeries: Series = new Series(
              this.labelMaxUpperQuantile,
              new Array<number>()
            );
            maxUpperQuantileSeries.tooltip = tooltipVoltage;
            maxUpperQuantileSeries.color = "#C0FE76";          //bright green

            const numberOfViolationsSeries: Series = new Series(
              this.labelViolations,
              new Array<number>()
            );
            numberOfViolationsSeries.tooltip = Config.getChartTooltip("");
            numberOfViolationsSeries.color = "#F54D65";             //bright red

            gMonOutputDatas.forEach((gMonOutputDataTmp) => {
              const gMonOutputData: GMonData = JSON.parse(gMonOutputDataTmp);
              const gridElementId = gMonOutputData.gridElementId;

              let gridElementName: string = "";
              const gridElement: GridElement = this.nodesMap.get(
                gridElementId
              ) as GridElement;
              if (gridElement) {
                gridElementName = gridElement.getPropertyValue("name");
              }
              xAxisCategories.push(gridElementName);

              let maxUpperQuantileTemp = null;
              if (gMonOutputData.voltageResult.maxUpperQuantile != null) {
                maxUpperQuantileTemp = parseFloat(
                  NumberUtils.format1(
                    gMonOutputData.voltageResult.maxUpperQuantile,
                    2
                  )
                );
                maxUpperQuantileSeries.data.push(maxUpperQuantileTemp);
              } else {
                console.log("areGMonQuantilesPresent")
                this.areGMonQuantilesPresent = false;
              }

              let minLowerQuantileTemp = null;
              if (gMonOutputData.voltageResult.minLowerQuantile != null) {
                minLowerQuantileTemp = parseFloat(
                  NumberUtils.format1(
                    gMonOutputData.voltageResult.minLowerQuantile,
                    2
                  )
                );
                minLowerQuantileSeries.data.push(minLowerQuantileTemp);
              }

              let avgAverageTemp = null;
              if (gMonOutputData.voltageResult.avgAverage != null) {
                avgAverageTemp = parseFloat(
                  NumberUtils.format1(
                    gMonOutputData.voltageResult.avgAverage,
                    2
                  )
                );
                avgSeries.data.push(avgAverageTemp);
              }

              let numberOfViolationsTemp = null;
              if (gMonOutputData.voltageResult.numberOfViolations != null) {
                numberOfViolationsTemp = parseFloat(
                  NumberUtils.format1(
                    gMonOutputData.voltageResult.numberOfViolations,
                    2
                  )
                );
                numberOfViolationsSeries.data.push(numberOfViolationsTemp);
              }
              numberOfViolationsSeries.yAxis = 1;
            });

            if (maxUpperQuantileSeries.data.length > 0) {
              series.push(maxUpperQuantileSeries);
            }
            if (minLowerQuantileSeries.data.length > 0) {
              series.push(minLowerQuantileSeries);
            }
            series.push(avgSeries);
            series.push(numberOfViolationsSeries);


            console.log(JSON.stringify(series));

            const god: GMonData = JSON.parse(gMonOutputDatas[0]);
            this.gmonTimeViewOptions.yAxis[0].plotLines[0].value =
              god.voltageResult.upperViolationLimit;
            this.gmonTimeViewOptions.yAxis[0].plotLines[1].value =
              god.voltageResult.lowerViolationLimit;

            (this.gmonTimeViewOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
            this.gmonTimeViewOptions.series = JSON.parse(
              JSON.stringify(series)
            );

            if (this.gmonTimeViewChart) {
              this.gmonTimeViewChart.options = this.gmonTimeViewOptions;
            }
          }



              /*
          if (maxUpperQuantileSeries.data.length == 0 && minLowerQuantileSeries.data.length == 0 && avgSeries.data.length == 0 && numberOfViolationsSeries.data.length==0) {
            this.isFeederChartEmpty = true;
          }
          else {
            this.isFeederChartEmpty = false;
          }
          */
         
          this.updateGmonTimeViewChartFlag = true;

        });
      });
    }

    //if user has not selected scenario
    else {
      this.applicationService.getGmonDataFeederView(gridElementIds).subscribe((gMonOutputDatas: Array<string>) => {
        console.log(gMonOutputDatas);
        if (!gMonOutputDatas || gMonOutputDatas.length == 0) {
          this.isFeederChartEmpty = true;
          return;
        }

        const tooltipVoltage: any = Config.getChartTooltip("V");

        const avgSeries: Series = new Series(
          this.labelAverage,
          new Array<number>()
        );
        avgSeries.color = "#85D9FF";    //bright blue
        avgSeries.tooltip = tooltipVoltage;

        const minLowerQuantileSeries: Series = new Series(
          this.labelMinLowerQuantile,
          new Array<number>()
        );
        minLowerQuantileSeries.tooltip = tooltipVoltage;
        minLowerQuantileSeries.color = "#C0FE76";          //bright green

        const maxUpperQuantileSeries: Series = new Series(
          this.labelMaxUpperQuantile,
          new Array<number>()
        );
        maxUpperQuantileSeries.tooltip = tooltipVoltage;
        maxUpperQuantileSeries.color = "#C0FE76";          //bright green

        const numberOfViolationsSeries: Series = new Series(
          this.labelViolations,
          new Array<number>()
        );
        numberOfViolationsSeries.tooltip = Config.getChartTooltip("");
        numberOfViolationsSeries.color = "#F54D65";      //bright red

        const xAxisCategories: Array<string> = new Array<string>();
        const series: Array<Series> = new Array<Series>();
        gMonOutputDatas.forEach((gMonOutputDataTmp) => {
          const gMonOutputData: GMonData = JSON.parse(gMonOutputDataTmp);
          const gridElementId = gMonOutputData.gridElementId;

          let gridElementName: string = "";
          const gridElement: GridElement = this.nodesMap.get(
            gridElementId
          ) as GridElement;
          if (gridElement) {
            gridElementName = gridElement.getPropertyValue("name");
          }
          xAxisCategories.push(gridElementName);
          // console.log("X AXIS FROM THE EXAMPLE >>> " , xAxisCategories)

          let maxUpperQuantileTemp = null;
          if (gMonOutputData.voltageResult.maxUpperQuantile != null) {
            maxUpperQuantileTemp = parseFloat(
              NumberUtils.format1(
                gMonOutputData.voltageResult.maxUpperQuantile,
                2
              )
            );
            maxUpperQuantileSeries.data.push(maxUpperQuantileTemp);
          } else {
            console.log("areGMonQuantilesPresent")
            this.areGMonQuantilesPresent = false;
          }

          let minLowerQuantileTemp = null;
          if (gMonOutputData.voltageResult.minLowerQuantile != null) {
            minLowerQuantileTemp = parseFloat(
              NumberUtils.format1(
                gMonOutputData.voltageResult.minLowerQuantile,
                2
              )
            );
            minLowerQuantileSeries.data.push(minLowerQuantileTemp);
          }

          let avgAverageTemp = null;
          if (gMonOutputData.voltageResult.avgAverage != null) {
            avgAverageTemp = parseFloat(
              NumberUtils.format1(
                gMonOutputData.voltageResult.avgAverage,
                2
              )
            );
            avgSeries.data.push(avgAverageTemp);
          }

          let numberOfViolationsTemp = null;
          if (gMonOutputData.voltageResult.numberOfViolations != null) {
            numberOfViolationsTemp = parseFloat(
              NumberUtils.format1(
                gMonOutputData.voltageResult.numberOfViolations,
                2
              )
            );
            numberOfViolationsSeries.data.push(numberOfViolationsTemp);
          }
          numberOfViolationsSeries.yAxis = 1;
        });

        if (maxUpperQuantileSeries.data.length > 0) {
          series.push(maxUpperQuantileSeries);
        }
        if (minLowerQuantileSeries.data.length > 0) {
          series.push(minLowerQuantileSeries);
        }
        series.push(avgSeries);
        series.push(numberOfViolationsSeries);

        console.log(JSON.stringify(series));

        const god: GMonData = JSON.parse(gMonOutputDatas[0]);
        this.gmonTimeViewOptions.yAxis[0].plotLines[0].value =
          god.voltageResult.upperViolationLimit;
        this.gmonTimeViewOptions.yAxis[0].plotLines[1].value =
          god.voltageResult.lowerViolationLimit;

        (this.gmonTimeViewOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
        // console.log("CHeCking the xAXIS from the exmppale ??? " , this.gmonTimeViewOptions)
        this.gmonTimeViewOptions.series = JSON.parse(
          JSON.stringify(series)
        );

        if (this.gmonTimeViewChart) {
          this.gmonTimeViewChart.options = this.gmonTimeViewOptions;
        }
            /*
        if (maxUpperQuantileSeries.data.length == 0 && minLowerQuantileSeries.data.length == 0 && avgSeries.data.length == 0 && numberOfViolationsSeries.data.length==0) {
          this.isFeederChartEmpty = true;
        }
        else {
          this.isFeederChartEmpty = false;
        }
        */
        
        this.updateGmonTimeViewChartFlag = true;
      });
    }

    
  }


  loadFeederChartWorstCase() {

    clearInterval(this.intervalVariable)

    this.isFeederChartEmpty = false;
    if (this.gridElementIdNodes) {
      this.feederChartWorstCase(this.gridElementIdNodes);
    } else {
      this.applicationService
        .getFeederNodes(this.gridElementId)
        .subscribe((gridElements: Array<any>) => {
          console.log(JSON.stringify(gridElements));
          const gridElementIds: Array<number> = new Array<number>();
          gridElements.forEach((gridElement: any) => {
            gridElementIds.push(gridElement.id);
          });
          this.feederChartWorstCase(gridElementIds);
          //  console.log(gridElementIds, gridElementIds);
        });
    }
  }


  private feederChartWorstCase(gridElementIds: Array<number>) {

    //if user has selected scenario
    if (this.selectedPlanningScenario == true) {
      this.applicationService.getGmonDataFeederViewPlanning(this.selectedScenario.id, gridElementIds).subscribe((gMonOutputDatas: Array<string>) => {
        console.log(gMonOutputDatas);

        const xAxisCategories: Array<string> = new Array<string>();
        const series: Array<Series> = new Array<Series>();
        const tooltipVoltage: any = Config.getChartTooltip("V");

        this.applicationService.getGmonDataFeederViewForPlanning(gridElementIds, this.selectedScenarioId).subscribe((gMonOutputDatasForPlanning: Array<string>) => {
          console.log("gMonOutputDatasForPlanning" + gMonOutputDatasForPlanning);

          if ((!gMonOutputDatas || gMonOutputDatas.length == 0) && (!gMonOutputDatasForPlanning || gMonOutputDatasForPlanning.length == 0)) {
            this.isFeederChartEmpty = true;
            return;
          }

          //////////////////////////////Feeder View Planning Series//////////////////////////////
          if (gMonOutputDatasForPlanning && gMonOutputDatasForPlanning.length > 0) {

            const avgSeriesPlanning: Series = new Series(
              this.labelWorstCaseFeederVoltage,
              new Array<number>()
            );
            avgSeriesPlanning.tooltip = tooltipVoltage;
            gMonOutputDatasForPlanning.forEach((gMonOutputDatasForPlanningTmp) => {
              const gMonOutputDataPlanning: GMonData = JSON.parse(gMonOutputDatasForPlanningTmp);
              let avgAverageTemp = null;
              if (gMonOutputDataPlanning.voltageResult.avgAverage != null) {
                avgAverageTemp = parseFloat(
                  NumberUtils.format1(
                    gMonOutputDataPlanning.voltageResult.avgAverage,
                    2
                  )
                );
                avgSeriesPlanning.data.push(avgAverageTemp);
              }
            });

            if (xAxisCategories.length == 0) {
              gMonOutputDatasForPlanning.forEach((gMonOutputDataTmp) => {
                const gMonOutputData: GMonData = JSON.parse(gMonOutputDataTmp);
                const gridElementId = gMonOutputData.gridElementId;
                let gridElementName: string = "";
                const gridElement: GridElement = this.nodesMap.get(
                  gridElementId
                ) as GridElement;
                if (gridElement) {
                  gridElementName = gridElement.getPropertyValue("name");
                }
                xAxisCategories.push(gridElementName);
              });
            }

            series.push(avgSeriesPlanning)
            const god: GMonData = JSON.parse(gMonOutputDatasForPlanning[0]);
            this.gmonTimeViewOptions.yAxis[0].plotLines[0].value =
              god.voltageResult.upperViolationLimit;
            this.gmonTimeViewOptions.yAxis[0].plotLines[1].value =
              god.voltageResult.lowerViolationLimit;

            (this.gmonTimeViewOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
            this.gmonTimeViewOptions.series = JSON.parse(
              JSON.stringify(series)
            );

            if (this.gmonTimeViewChart) {
              this.gmonTimeViewChart.options = this.gmonTimeViewOptions;
            }



          }

          /////////////////////////////////////////////////////////////////////////////////////

          if (gMonOutputDatas && gMonOutputDatas.length > 0) {
            const avgSeries: Series = new Series(
              this.labelAverage,
              new Array<number>()
            );
            avgSeries.tooltip = tooltipVoltage;

            if (xAxisCategories.length == 0) {
              gMonOutputDatas.forEach((gMonOutputDataTmp) => {
                const gMonOutputData: GMonData = JSON.parse(gMonOutputDataTmp);
                const gridElementId = gMonOutputData.gridElementId;
                let gridElementName: string = "";
                const gridElement: GridElement = this.nodesMap.get(
                  gridElementId
                ) as GridElement;
                if (gridElement) {
                  gridElementName = gridElement.getPropertyValue("name");
                }
                xAxisCategories.push(gridElementName);
              });
            }

            gMonOutputDatas.forEach((gMonOutputDataTmp) => {
              const gMonOutputData: GMonData = JSON.parse(gMonOutputDataTmp);
              let avgAverageTemp = null;
              if (gMonOutputData.voltageResult.avgAverage != null) {
                avgAverageTemp = parseFloat(
                  NumberUtils.format1(
                    gMonOutputData.voltageResult.avgAverage,
                    2
                  )
                );
                avgSeries.data.push(avgAverageTemp);
              }
            });
            series.push(avgSeries);
            console.log(JSON.stringify(series));
            const god: GMonData = JSON.parse(gMonOutputDatas[0]);
            this.gmonTimeViewOptions.yAxis[0].plotLines[0].value =
              god.voltageResult.upperViolationLimit;
            this.gmonTimeViewOptions.yAxis[0].plotLines[1].value =
              god.voltageResult.lowerViolationLimit;

            (this.gmonTimeViewOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
            this.gmonTimeViewOptions.series = JSON.parse(
              JSON.stringify(series)
            );

            if (this.gmonTimeViewChart) {
              this.gmonTimeViewChart.options = this.gmonTimeViewOptions;
            }
            
            this.updateGmonTimeViewChartFlag = true;
          }
        });
      });
    }

  }


  loadCableLoading() {

    clearInterval(this.intervalVariable)

    this.applicationService
      .getLACableData(this.gridElementId)
      .subscribe((cableResults: string) => {
        if (!cableResults || cableResults.length == 0) {
          return;
        }
        const cableData: LoadingAnalysisData = JSON.parse(cableResults);

        const xAxisCategories: Map<String, String> = new Map<String, String>();
        const series: Array<Series> = new Array<Series>();
        let maximumValue = cableData.cableViolationLimitPercent;
        const allValues: Array<number> = new Array<number>();

        const loadData: Array<number> = new Array<number>();
        cableData.intervals.forEach((value) => {
          const timestamp = value.timestamp;
           if(value.source == "forecast"){
            this.forecastLaDataMap.push(value.timestamp);
            }
          xAxisCategories.set(timestamp, timestamp);
          let valueFloat = null;
          if (value != null && value.loadPercent != null) {
            valueFloat = parseFloat(
              NumberUtils.format1(value.loadPercent, 2)
            );
          }
          if(valueFloat> maximumValue)
            maximumValue = valueFloat;
          loadData.push(valueFloat);
          allValues.push(valueFloat);
        });
        const loadSeries: Series = new Series(this.labelLoad, loadData);
        loadSeries.tooltip = Config.getChartTooltip("%");
        loadSeries.color = "#85D9FF";  //lightblue Color

        series.push(loadSeries);

        console.log(JSON.stringify(series));
        // set Violation-Limit
        this.cableLoadingOptions.yAxis[0].plotLines[0].value =
          cableData.cableViolationLimitPercent;
        this.cableLoadingOptions.yAxis[0].max = maximumValue * 1.1;
        this.cableLoadingOptions.yAxis[0].min = 0;

        const categories: string[] = [];
        xAxisCategories.forEach((key: string) => {
          categories.push(key);
        });

        this.cableLoadingOptions = {
          ...this.cableLoadingOptions,
          xAxis: {
            ...this.cableLoadingOptions.xAxis,
            categories: categories
          },
          series: JSON.parse(JSON.stringify(series))
        }

        console.log("Legend of the graph: ", this.cableLoadingOptions.legend);

        this.updateCableLoadingTimeViewFlag = true;
      });
  }

  // gplan
  gplanLoadCableLoading() {

    this.applicationService
      .getGplanLACableData(this.selectedScenario.id, this.gridElementId)
      .subscribe((cableGplanResults: string) => {
        if (!cableGplanResults || cableGplanResults.length === 0) {

          return;
        }
        const cableGplanData: LoadingAnalysisData =
          JSON.parse(cableGplanResults);

        const xAxisCategories: Map<string, string> = new Map<string, string>();
        const series: Array<Series> = new Array<Series>();

        const loadGplanData: Array<number> = new Array<number>();
        cableGplanData.intervals.forEach((value) => {
          const timestamp = value.timestamp;
          xAxisCategories.set(timestamp, timestamp);
          let valueFloat = null;
          if (value != null && value.loadPercent != null) {
            valueFloat = parseFloat(
              NumberUtils.format1(value.loadPercent, 2)
            );
          }
          loadGplanData.push(valueFloat);
        });
        const loadGplanSeries: Series = new Series(
          this.labelPlanningLoad,
          loadGplanData
        );
        loadGplanSeries.tooltip = Config.getChartTooltip("%");
        loadGplanSeries.color = "#0569C3";   //dark blue
        series.push(loadGplanSeries);
        // console.log(JSON.stringify(series));

        this.applicationService
          .getLACableDataInPlanning(this.selectedScenario.id, this.gridElementId)
          .subscribe((cableResults: string) => {
            if (!cableResults || cableResults.length == 0) {
              // set Violation-Limit
              this.gplanCableLoadingOptions.yAxis[0].plotLines[0].value =
                cableGplanData.cableViolationLimitPercent;
              (this.gplanCableLoadingOptions.xAxis as Highcharts.XAxisOptions).categories = [];
              xAxisCategories.forEach((key: string) => {
                (this.gplanCableLoadingOptions.xAxis as Highcharts.XAxisOptions).categories.push(key);
              });

              this.gplanCableLoadingOptions.series = JSON.parse(
                JSON.stringify(series)
              );
              console.log(JSON.stringify(this.gplanCableLoadingOptions));
              if (this.cableLoadingChart) {
                this.cableLoadingChart.options = this.gplanCableLoadingOptions;
              }
              return;
            }
            const cableData: LoadingAnalysisData = JSON.parse(cableResults);
            const loadData: Array<number> = new Array<number>();
            cableData.intervals.forEach((value) => {
              const timestamp = value.timestamp;
                         if(value.source == "forecast"){
                          this.forecastLaPlanningDataMap.push(value.timestamp);
                          }
              xAxisCategories.set(timestamp, timestamp);
              let valueFloat = null;
              if (value != null && value.loadPercent != null) {
                valueFloat = parseFloat(
                  NumberUtils.format1(value.loadPercent, 2)
                );
              }
              loadData.push(valueFloat);
              // allValues.push(valueFloat);
            });
            const loadSeries: Series = new Series(this.labelLoad, loadData);
            loadSeries.tooltip = Config.getChartTooltip("%");
            loadSeries.color = "#85D9FF";  //bright blue
            series.push(loadSeries);

            console.log(JSON.stringify(series));
            // set Violation-Limit
            this.gplanCableLoadingOptions.yAxis[0].plotLines[0].value =
              cableData.cableViolationLimitPercent;

            (this.gplanCableLoadingOptions.xAxis as Highcharts.XAxisOptions).categories = [];
            xAxisCategories.forEach((key: string) => {
              (this.gplanCableLoadingOptions.xAxis as Highcharts.XAxisOptions).categories.push(key);
            });
                    if(this.forecastLaPlanningDataMap.length > 0){
                      (this.gplanCableLoadingOptions.xAxis as Highcharts.XAxisOptions).plotBands = [{
                        color:"#dddddd",
                        from: (this.gplanCableLoadingOptions.xAxis as Highcharts.XAxisOptions).categories.indexOf(this.forecastLaPlanningDataMap[0]) - 0.5,
                        to: (this.gplanCableLoadingOptions.xAxis as Highcharts.XAxisOptions).categories.indexOf(this.forecastLaPlanningDataMap[this.forecastLaPlanningDataMap.length - 1]) + 0.5,
                      }]
                    }
            this.gplanCableLoadingOptions.series = JSON.parse(
              JSON.stringify(series)
            );
            console.log(JSON.stringify(this.gplanCableLoadingOptions));
            if (this.gplanCableLoadingChart) {
              this.gplanCableLoadingChart.options =
                this.gplanCableLoadingOptions;
            }

          });
      });
  }

  gplanLoadCableLoadingWorstCase() {

    this.gplanCableLoadingOptions.chart.type = "column"
    this.applicationService
      .getGplanLACableData(this.selectedScenario.id, this.gridElementId)
      .subscribe((cableGplanResults: string) => {
        if (!cableGplanResults || cableGplanResults.length === 0) {

          return;
        }
        const cableGplanData: LoadingAnalysisData =
          JSON.parse(cableGplanResults);

        const xAxisCategories: Map<string, string> = new Map<string, string>();
        const series: Array<Series> = new Array<Series>();

        const loadGplanData: Array<number> = new Array<number>();
        cableGplanData.intervals.forEach((value) => {
          const timestamp = value.timestamp;
          xAxisCategories.set(timestamp, timestamp);
          let valueFloat = null;
          if (value != null && value.loadPercent != null) {
            valueFloat = parseFloat(
              NumberUtils.format1(value.loadPercent, 2)
            );
          }
          loadGplanData.push(valueFloat);
        });
        const loadGplanSeries: Series = new Series(
          this.labelWorstCaseLoad,
          loadGplanData
        );
        loadGplanSeries.tooltip = Config.getChartTooltip("%");
        series.push(loadGplanSeries);
        // console.log(JSON.stringify(series));

        this.applicationService
          .getLACableDataInPlanning(this.selectedScenario.id, this.gridElementId)
          .subscribe((cableResults: string) => {
            if (!cableResults || cableResults.length == 0) {
              // set Violation-Limit
              this.gplanCableLoadingOptions.yAxis[0].plotLines[0].value =
                cableGplanData.cableViolationLimitPercent;
              (this.gplanCableLoadingOptions.xAxis as Highcharts.XAxisOptions).categories = [];
              xAxisCategories.forEach((key: string) => {
                (this.gplanCableLoadingOptions.xAxis as Highcharts.XAxisOptions).categories.push(key);
              });

              this.gplanCableLoadingOptions.series = JSON.parse(
                JSON.stringify(series)
              );
              console.log(JSON.stringify(this.gplanCableLoadingOptions));
              if (this.cableLoadingChart) {
                this.cableLoadingChart.options = this.gplanCableLoadingOptions;
              }
              return;
            }
            const cableData: LoadingAnalysisData = JSON.parse(cableResults);
            const loadData: Array<number> = new Array<number>();
            cableData.intervals.forEach((value) => {
              const timestamp = value.timestamp;
              xAxisCategories.set(timestamp, timestamp);
            let valueFloat = null;
            if (value != null && value.loadPercent != null) {
              valueFloat = parseFloat(
                NumberUtils.format1(value.loadPercent, 2)
              );
            }

              loadData.push(valueFloat);
              // allValues.push(valueFloat);
            });
            const loadSeries: Series = new Series(this.labelLoad, loadData);
            loadSeries.tooltip = Config.getChartTooltip("%");

            series.push(loadSeries);

            console.log(JSON.stringify(series));
            // set Violation-Limit
            this.gplanCableLoadingOptions.yAxis[0].plotLines[0].value =
              cableData.cableViolationLimitPercent;

            (this.gplanCableLoadingOptions.xAxis as Highcharts.XAxisOptions).categories = [];
            xAxisCategories.forEach((key: string) => {
              (this.gplanCableLoadingOptions.xAxis as Highcharts.XAxisOptions).categories.push(key);
            });

            this.gplanCableLoadingOptions.series = JSON.parse(
              JSON.stringify(series)
            );
            console.log(JSON.stringify(this.gplanCableLoadingOptions));
            if (this.gplanCableLoadingChart) {
              this.gplanCableLoadingChart.options =
                this.gplanCableLoadingOptions;
            }

          });
      });
  }

  loadFeederViewCables(): void {

    clearInterval(this.intervalVariable)

    if (this.gridElementIdcables) {
      this.feederViewCables(this.gridElementIdcables);
    } else {
      this.applicationService
        .getFeederCables(this.gridElementId)
        .subscribe((cables: Array<any>) => {
          console.log(cables);

          const cableGridElementIds: Array<number> = new Array<number>();
          cables.forEach((cable: any) => {
            cableGridElementIds.push(cable.GridElement.id);
          });
          this.feederViewCables(cableGridElementIds);
        });
    }
  }

  private feederViewCables(cableGridElementIds: Array<number>) {
    //if user has selected scenario
    if (this.selectedPlanningScenario == true) {
      this.applicationService.getLACablesDataFeederViewPlanning(this.selectedScenario.id, cableGridElementIds).subscribe((laCableOutputDatas: Array<string>) => {
        console.log(laCableOutputDatas);

        const xAxisCategories: Array<string> = new Array<string>();
        const series: Array<Series> = new Array<Series>();

        //call API by scenarioId
        this.applicationService.getLACablesDataFeederViewByScenarioId(cableGridElementIds, this.selectedScenarioId).subscribe((laCableOutputDatasPlanning: Array<string>) => {
          console.log(laCableOutputDatasPlanning);

          //////////////////////////////Feeder View Planning Series//////////////////////////////
          if (laCableOutputDatasPlanning && laCableOutputDatasPlanning.length > 0) {
            const tooltipAvgLoadPlanning: any = Config.getChartTooltip("%");
            const avgLoadSeriesPlanning: Series = new Series(
              this.labelAverageLoadPlanning,
              new Array<number>()
            );
            avgLoadSeriesPlanning.tooltip = tooltipAvgLoadPlanning;
            avgLoadSeriesPlanning.color = "#26C02D";     //dark green

            const tooltipMaxLoadPlanning: any = Config.getChartTooltip("%");
            const maxLoadSeriesPlanning: Series = new Series(
              this.labelMaxLoadPlanning,
              new Array<number>()
            );
            maxLoadSeriesPlanning.tooltip = tooltipMaxLoadPlanning;
            maxLoadSeriesPlanning.color = "#0569C3";   //dark blue

            const numberOfViolationsSeriesPlanning: Series = new Series(
              this.labelViolationsPlanning,
              new Array<number>()
            );
            numberOfViolationsSeriesPlanning.tooltip = Config.getChartTooltip("");
            numberOfViolationsSeriesPlanning.color = "#96081C"; //dark red

            laCableOutputDatasPlanning.forEach((laNodeOutputDataTmpPlanning: any) => {
              const loadingAnalysisNodeOutputData: LoadingAnalysisData =
                JSON.parse(laNodeOutputDataTmpPlanning);
              avgLoadSeriesPlanning.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisNodeOutputData.avgLoadPercent,
                    2
                  )
                )
              );
              maxLoadSeriesPlanning.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisNodeOutputData.maxLoadPercent,
                    2
                  )
                )
              );
              numberOfViolationsSeriesPlanning.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisNodeOutputData.numberOfViolations,
                    2
                  )
                )
              );
              numberOfViolationsSeriesPlanning.yAxis = 1;
            });

            series.push(avgLoadSeriesPlanning);
            series.push(maxLoadSeriesPlanning);
            series.push(numberOfViolationsSeriesPlanning);
          }
          ///////////////////////////////////////////////////////////////////////////////////////////

          if (laCableOutputDatas && laCableOutputDatas.length > 0) {

            const tooltipAvgLoad: any = Config.getChartTooltip("%");
            const avgLoadSeries: Series = new Series(
              this.labelAverageLoad,
              new Array<number>()
            );
            avgLoadSeries.tooltip = tooltipAvgLoad;
            avgLoadSeries.color = "#C0FE76";     //bright green

            const tooltipMaxLoad: any = Config.getChartTooltip("%");
            const maxLoadSeries: Series = new Series(
              this.labelMaxLoad,
              new Array<number>()
            );
            maxLoadSeries.tooltip = tooltipMaxLoad;
            maxLoadSeries.color = "#85D9FF";         //bright blue

            const numberOfViolationsSeries: Series = new Series(
              this.labelViolations,
              new Array<number>()
            );
            numberOfViolationsSeries.tooltip = Config.getChartTooltip("");
            numberOfViolationsSeries.color = "#F54D65";      //bright red

            const laOutputData: LoadingAnalysisData = JSON.parse(
              laCableOutputDatas[0]
            );
            this.feederViewCablesOptions.yAxis[0].plotLines[0].value =
              laOutputData.cableViolationLimitPercent;

            laCableOutputDatas.forEach((laNodeOutputDataTmp: any) => {
              const loadingAnalysisNodeOutputData: LoadingAnalysisData =
                JSON.parse(laNodeOutputDataTmp);
              const gridElementId = parseInt(
                loadingAnalysisNodeOutputData.gridElementId
              );

              let gridElementName: string = "";
              const cable = this.cablesMap.get(gridElementId) as Cable;
              if (cable == null) {
                console.error(
                  "Cable with GridElement ID " + gridElementId + " is null"
                );
                return;
              }
              const startGridElement: GridElement = this.nodesMap.get(
                cable.startNodeId
              ) as GridElement;
              const endGridElement: GridElement = this.nodesMap.get(
                cable.endNodeId
              ) as GridElement;
              if (startGridElement && endGridElement) {
                gridElementName =
                  startGridElement.getPropertyValue("name") +
                  " - " +
                  endGridElement.getPropertyValue("name");
              }
              xAxisCategories.push(gridElementName);

              avgLoadSeries.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisNodeOutputData.avgLoadPercent,
                    2
                  )
                )
              );

              maxLoadSeries.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisNodeOutputData.maxLoadPercent,
                    2
                  )
                )
              );

              numberOfViolationsSeries.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisNodeOutputData.numberOfViolations,
                    2
                  )
                )
              );
              numberOfViolationsSeries.yAxis = 1;
            });

            series.push(avgLoadSeries);
            series.push(maxLoadSeries);
            series.push(numberOfViolationsSeries);
          }

          console.log(JSON.stringify(series));
          (this.feederViewCablesOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
          this.feederViewCablesOptions.series = JSON.parse(
            JSON.stringify(series)
          );
          if (this.feederViewCablesChart) {
            this.feederViewCablesChart.options = this.feederViewCablesOptions;
          }
        });

        
        this.updateFeederViewCablesChartFlag = true;
      });

    }
    //if user has not selected scenario
    else {
      this.applicationService.getLACablesDataFeederView(cableGridElementIds).subscribe((laCableOutputDatas: Array<string>) => {
        console.log(laCableOutputDatas);
        if (laCableOutputDatas == null || laCableOutputDatas.length == 0) {
          return;
        }

        const tooltipAvgLoad: any = Config.getChartTooltip("%");
        const avgLoadSeries: Series = new Series(
          this.labelAverageLoad,
          new Array<number>()
        );
        avgLoadSeries.tooltip = tooltipAvgLoad;
        avgLoadSeries.color = "#C0FE76";

        const tooltipMaxLoad: any = Config.getChartTooltip("%");
        const maxLoadSeries: Series = new Series(
          this.labelMaxLoad,
          new Array<number>()
        );
        maxLoadSeries.tooltip = tooltipMaxLoad;
        maxLoadSeries.color = "#85D9FF";

        const numberOfViolationsSeries: Series = new Series(
          this.labelViolations,
          new Array<number>()
        );
        numberOfViolationsSeries.tooltip = Config.getChartTooltip("");
        numberOfViolationsSeries.color = "#F54D65";

        const laOutputData: LoadingAnalysisData = JSON.parse(
          laCableOutputDatas[0]
        );
        this.feederViewCablesOptions.yAxis[0].plotLines[0].value =
          laOutputData.cableViolationLimitPercent;
        const xAxisCategories: Array<string> = new Array<string>();
        const series: Array<Series> = new Array<Series>();
        laCableOutputDatas.forEach((laNodeOutputDataTmp: any) => {
          const loadingAnalysisNodeOutputData: LoadingAnalysisData =
            JSON.parse(laNodeOutputDataTmp);
          const gridElementId = parseInt(
            loadingAnalysisNodeOutputData.gridElementId
          );

          let gridElementName: string = "";
          const cable = this.cablesMap.get(gridElementId) as Cable;
          if (cable == null) {
            console.error(
              "Cable with GridElement ID " + gridElementId + " is null"
            );
            return;
          }
          const startGridElement: GridElement = this.nodesMap.get(
            cable.startNodeId
          ) as GridElement;
          const endGridElement: GridElement = this.nodesMap.get(
            cable.endNodeId
          ) as GridElement;
          if (startGridElement && endGridElement) {
            gridElementName =
              startGridElement.getPropertyValue("name") +
              " - " +
              endGridElement.getPropertyValue("name");
          }
          xAxisCategories.push(gridElementName);

          avgLoadSeries.data.push(
            parseFloat(
              NumberUtils.format1(
                loadingAnalysisNodeOutputData.avgLoadPercent,
                2
              )
            )
          );

          maxLoadSeries.data.push(
            parseFloat(
              NumberUtils.format1(
                loadingAnalysisNodeOutputData.maxLoadPercent,
                2
              )
            )
          );

          numberOfViolationsSeries.data.push(
            parseFloat(
              NumberUtils.format1(
                loadingAnalysisNodeOutputData.numberOfViolations,
                2
              )
            )
          );
          numberOfViolationsSeries.yAxis = 1;
        });

        series.push(avgLoadSeries);
        series.push(maxLoadSeries);
        series.push(numberOfViolationsSeries);

        console.log(JSON.stringify(series));

        (this.feederViewCablesOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
        this.feederViewCablesOptions.series = JSON.parse(
          JSON.stringify(series)
        );
        if (this.feederViewCablesChart) {
          this.feederViewCablesChart.options = this.feederViewCablesOptions;
        }

        
        this.updateFeederViewCablesChartFlag = true;
      });
    }
  }

  loadFeederViewCablesWorstCase(): void {

    clearInterval(this.intervalVariable)

    if (this.gridElementIdcables) {
      this.feederViewCablesWorstCase(this.gridElementIdcables);
    } else {
      this.applicationService
        .getFeederCables(this.gridElementId)
        .subscribe((cables: Array<any>) => {
          console.log(cables);

          const cableGridElementIds: Array<number> = new Array<number>();
          cables.forEach((cable: any) => {
            cableGridElementIds.push(cable.GridElement.id);
          });
          this.feederViewCablesWorstCase(cableGridElementIds);
        });
    }

  }

  private feederViewCablesWorstCase(cableGridElementIds: Array<number>) {
    //if user has selected scenario
    if (this.selectedPlanningScenario == true) {
      this.applicationService.getLACablesDataFeederViewPlanning(this.selectedScenario.id, cableGridElementIds).subscribe((laCableOutputDatas: Array<string>) => {
        console.log(laCableOutputDatas);

        const xAxisCategories: Array<string> = new Array<string>();
        const series: Array<Series> = new Array<Series>();

        //call API by scenarioId
        this.applicationService.getLACablesDataFeederViewByScenarioId(cableGridElementIds, this.selectedScenarioId).subscribe((laCableOutputDatasPlanning: Array<string>) => {
          console.log(laCableOutputDatasPlanning);

          //////////////////////////////Feeder View Planning Series//////////////////////////////
          if (laCableOutputDatasPlanning && laCableOutputDatasPlanning.length > 0) {
            const tooltipMaxLoadPlanning: any = Config.getChartTooltip("%");
            const maxLoadSeriesPlanning: Series = new Series(
              this.labelLoadWorstCase,
              new Array<number>()
            );
            maxLoadSeriesPlanning.tooltip = tooltipMaxLoadPlanning;
            maxLoadSeriesPlanning.color = "#FF1600";

            const numberOfViolationsSeriesPlanning: Series = new Series(
              this.labelViolationsPlanning,
              new Array<number>()
            );
            numberOfViolationsSeriesPlanning.tooltip = Config.getChartTooltip("");
            numberOfViolationsSeriesPlanning.color = "#690101";

            laCableOutputDatasPlanning.forEach((laNodeOutputDataTmpPlanning: any) => {
              const loadingAnalysisNodeOutputData: LoadingAnalysisData =
                JSON.parse(laNodeOutputDataTmpPlanning);

              maxLoadSeriesPlanning.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisNodeOutputData.maxLoadPercent,
                    2
                  )
                )
              );
              numberOfViolationsSeriesPlanning.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisNodeOutputData.numberOfViolations,
                    2
                  )
                )
              );
              numberOfViolationsSeriesPlanning.yAxis = 1;
            });

            series.push(maxLoadSeriesPlanning);
            //series.push(numberOfViolationsSeriesPlanning);

            if (xAxisCategories.length == 0) {
              laCableOutputDatasPlanning.forEach((laNodeOutputDataTmp: any) => {
                const loadingAnalysisNodeOutputData: LoadingAnalysisData =
                  JSON.parse(laNodeOutputDataTmp);
                const gridElementId = parseInt(
                  loadingAnalysisNodeOutputData.gridElementId
                );

                let gridElementName: string = "";
                const cable = this.cablesMap.get(gridElementId) as Cable;
                if (cable == null) {
                  console.error(
                    "Cable with GridElement ID " + gridElementId + " is null"
                  );
                  return;
                }
                const startGridElement: GridElement = this.nodesMap.get(
                  cable.startNodeId
                ) as GridElement;
                const endGridElement: GridElement = this.nodesMap.get(
                  cable.endNodeId
                ) as GridElement;
                if (startGridElement && endGridElement) {
                  gridElementName =
                    startGridElement.getPropertyValue("name") +
                    " - " +
                    endGridElement.getPropertyValue("name");
                }
                xAxisCategories.push(gridElementName);
              });
            }

          }
          ///////////////////////////////////////////////////////////////////////////////////////////

          if (laCableOutputDatas && laCableOutputDatas.length > 0) {



            const tooltipMaxLoad: any = Config.getChartTooltip("%");
            const maxLoadSeries: Series = new Series(
              this.labelLoadWorstCase,
              new Array<number>()
            );
            maxLoadSeries.tooltip = tooltipMaxLoad;
            maxLoadSeries.color = "#FF6600";

            const numberOfViolationsSeries: Series = new Series(
              this.labelViolations,
              new Array<number>()
            );
            numberOfViolationsSeries.tooltip = Config.getChartTooltip("");
            numberOfViolationsSeries.color = "#c90000";

            const laOutputData: LoadingAnalysisData = JSON.parse(
              laCableOutputDatas[0]
            );
            this.feederViewCablesOptions.yAxis[0].plotLines[0].value =
              laOutputData.cableViolationLimitPercent;

            if (xAxisCategories.length == 0) {

              laCableOutputDatas.forEach((laNodeOutputDataTmp: any) => {
                const loadingAnalysisNodeOutputData: LoadingAnalysisData = JSON.parse(laNodeOutputDataTmp);
                const gridElementId = parseInt(loadingAnalysisNodeOutputData.gridElementId);
                let gridElementName: string = "";
                const cable = this.cablesMap.get(gridElementId) as Cable;
                if (cable == null) {
                  console.error(
                    "Cable with GridElement ID " + gridElementId + " is null"
                  );
                  return;
                }
                const startGridElement: GridElement = this.nodesMap.get(
                  cable.startNodeId
                ) as GridElement;
                const endGridElement: GridElement = this.nodesMap.get(
                  cable.endNodeId
                ) as GridElement;
                if (startGridElement && endGridElement) {
                  gridElementName =
                    startGridElement.getPropertyValue("name") +
                    " - " +
                    endGridElement.getPropertyValue("name");
                }
                xAxisCategories.push(gridElementName);
              });

            }


            laCableOutputDatas.forEach((laNodeOutputDataTmp: any) => {
              const loadingAnalysisNodeOutputData: LoadingAnalysisData = JSON.parse(laNodeOutputDataTmp);

              maxLoadSeries.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisNodeOutputData.maxLoadPercent,
                    2
                  )
                )
              );

              numberOfViolationsSeries.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisNodeOutputData.numberOfViolations,
                    2
                  )
                )
              );
              numberOfViolationsSeries.yAxis = 1;
              this.feederViewCablesOptions.yAxis[0].plotLines[0].value = loadingAnalysisNodeOutputData.cableViolationLimitPercent;
            });

            series.push(maxLoadSeries);
            //series.push(numberOfViolationsSeries);
          }

          console.log(JSON.stringify(series));
          (this.feederViewCablesOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;

          this.feederViewCablesOptions.series = JSON.parse(
            JSON.stringify(series)
          );
          if (this.feederViewCablesChart) {
            this.feederViewCablesChart.options = this.feederViewCablesOptions;
          }
        });
      });

    }
    //if user has not selected scenario
    //TODO it is possible remove this else statement becouse in worst case user always selected scenario
    else {
      this.applicationService.getLACablesDataFeederView(cableGridElementIds).subscribe((laCableOutputDatas: Array<string>) => {
        console.log(laCableOutputDatas);
        if (laCableOutputDatas == null || laCableOutputDatas.length == 0) {
          return;
        }
        const tooltipMaxLoad: any = Config.getChartTooltip("%");
        const maxLoadSeries: Series = new Series(
          this.labelLoadWorstCase,
          new Array<number>()
        );
        maxLoadSeries.tooltip = tooltipMaxLoad;
        maxLoadSeries.color = "#FF6600";

        const numberOfViolationsSeries: Series = new Series(
          this.labelViolations,
          new Array<number>()
        );
        numberOfViolationsSeries.tooltip = Config.getChartTooltip("");
        numberOfViolationsSeries.color = "#c90000";

        const laOutputData: LoadingAnalysisData = JSON.parse(
          laCableOutputDatas[0]
        );
        this.feederViewCablesOptions.yAxis[0].plotLines[0].value =
          laOutputData.cableViolationLimitPercent;
        const xAxisCategories: Array<string> = new Array<string>();
        const series: Array<Series> = new Array<Series>();
        laCableOutputDatas.forEach((laNodeOutputDataTmp: any) => {
          const loadingAnalysisNodeOutputData: LoadingAnalysisData =
            JSON.parse(laNodeOutputDataTmp);
          const gridElementId = parseInt(
            loadingAnalysisNodeOutputData.gridElementId
          );

          let gridElementName: string = "";
          const cable = this.cablesMap.get(gridElementId) as Cable;
          if (cable == null) {
            console.error(
              "Cable with GridElement ID " + gridElementId + " is null"
            );
            return;
          }
          const startGridElement: GridElement = this.nodesMap.get(
            cable.startNodeId
          ) as GridElement;
          const endGridElement: GridElement = this.nodesMap.get(
            cable.endNodeId
          ) as GridElement;
          if (startGridElement && endGridElement) {
            gridElementName =
              startGridElement.getPropertyValue("name") +
              " - " +
              endGridElement.getPropertyValue("name");
          }
          xAxisCategories.push(gridElementName);



          maxLoadSeries.data.push(
            parseFloat(
              NumberUtils.format1(
                loadingAnalysisNodeOutputData.maxLoadPercent,
                2
              )
            )
          );

          numberOfViolationsSeries.data.push(
            parseFloat(
              NumberUtils.format1(
                loadingAnalysisNodeOutputData.numberOfViolations,
                2
              )
            )
          );
          numberOfViolationsSeries.yAxis = 1;
        });

        series.push(maxLoadSeries);
        // series.push(numberOfViolationsSeries);

        console.log(JSON.stringify(series));

        (this.feederViewCablesOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
        this.feederViewCablesOptions.series = JSON.parse(
          JSON.stringify(series)
        );
        if (this.feederViewCablesChart) {
          this.feederViewCablesChart.options = this.feederViewCablesOptions;
        }
      }
      );
    }
  }

  loadFeederViewNodes() {

    clearInterval(this.intervalVariable)

    if (this.gridElementIdNodes) {
      this.feederViewNodes(this.gridElementIdNodes);
    } else {
      this.applicationService
        .getFeederNodes(this.gridElementId)
        .subscribe((gridElements: Array<any>) => {
          console.log(gridElements);
          const gridElementIds: Array<number> = new Array<number>();
          gridElements.forEach((gridElement: any) => {
            gridElementIds.push(gridElement.id);
          });
          this.feederViewNodes(gridElementIds);
        });
    }
  }

  private feederViewNodes(gridElementIds: Array<number>) {
    //if user has selected scenario
    if (this.selectedPlanningScenario == true) {

      this.applicationService.getLANodesDataFeederViewPlanning(this.selectedScenario.id, gridElementIds).subscribe((laNodeOutputDatas: Array<string>) => {
        console.log(laNodeOutputDatas);

        this.applicationService.getLANodesDataFeederViewByScenarioId(gridElementIds, this.selectedScenarioId).subscribe((laNodeOutputDatasPlanning: Array<string>) => {
          console.log(laNodeOutputDatasPlanning)
          const xAxisCategories: Array<string> = new Array<string>();
          const series: Array<Series> = new Array<Series>();


          //////////////////////////////Feeder View Planning Series//////////////////////////////
          if (laNodeOutputDatasPlanning && laNodeOutputDatasPlanning.length > 0) {
            const tooltipAvgLoadPlanning: any = Config.getChartTooltip("%");
            const avgLoadSeriesPlanning: Series = new Series(
              this.labelAverageLoadPlanning,
              new Array<number>()
            );
            avgLoadSeriesPlanning.tooltip = tooltipAvgLoadPlanning;
            avgLoadSeriesPlanning.color = "#26C02D";     //dark green

            const tooltipMaxLoadPlanning: any = Config.getChartTooltip("%");
            const maxLoadSeriesPlanning: Series = new Series(
              this.labelMaxLoadPlanning,
              new Array<number>()
            );
            maxLoadSeriesPlanning.tooltip = tooltipMaxLoadPlanning;
            maxLoadSeriesPlanning.color = "#0569C3";           //dark blue

            const numberOfViolationsSeriesPlanning: Series = new Series(
              this.labelViolationsPlanning,
              new Array<number>()
            );
            numberOfViolationsSeriesPlanning.tooltip = Config.getChartTooltip("");
            numberOfViolationsSeriesPlanning.color = "#96081C";    //dark red

            laNodeOutputDatasPlanning.forEach((laNodeOutputDataTmpPlanning: any) => {
              const loadingAnalysisOutputDataPlanning: LoadingAnalysisData =
                JSON.parse(laNodeOutputDataTmpPlanning);


              avgLoadSeriesPlanning.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisOutputDataPlanning.avgLoadPercent,
                    2
                  )
                )
              );
              maxLoadSeriesPlanning.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisOutputDataPlanning.maxLoadPercent,
                    2
                  )
                )
              );

              numberOfViolationsSeriesPlanning.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisOutputDataPlanning.numberOfViolations,
                    2
                  )
                )
              );
              numberOfViolationsSeriesPlanning.yAxis = 1;
            });

            series.push(avgLoadSeriesPlanning);
            series.push(maxLoadSeriesPlanning);
            series.push(numberOfViolationsSeriesPlanning);
          }
          ///////////////////////////////////////////////////////////////////////////////////////////


          if (laNodeOutputDatas && laNodeOutputDatas.length > 0) {
            const tooltipAvgLoad: any = Config.getChartTooltip("%");
            const avgLoadSeries: Series = new Series(
              this.labelAverageLoad,
              new Array<number>()
            );
            avgLoadSeries.tooltip = tooltipAvgLoad;
            avgLoadSeries.color = "#C0FE76";    //bright green

            const tooltipMaxLoad: any = Config.getChartTooltip("%");
            const maxLoadSeries: Series = new Series(
              this.labelMaxLoad,
              new Array<number>()
            );
            maxLoadSeries.tooltip = tooltipMaxLoad;
            maxLoadSeries.color = "#85D9FF";         //bright blue

            const numberOfViolationsSeries: Series = new Series(
              this.labelViolations,
              new Array<number>()
            );
            numberOfViolationsSeries.tooltip = Config.getChartTooltip("");
            numberOfViolationsSeries.color = "#F54D65";     //bright red

            const laOutputData: LoadingAnalysisData = JSON.parse(
              laNodeOutputDatas[0]
            );
            this.feederViewNodesOptions.yAxis[0].plotLines[0].value =
              laOutputData.nodeViolationLimitPercent;


            laNodeOutputDatas.forEach((laNodeOutputDataTmp: any) => {
              const loadingAnalysisOutputData: LoadingAnalysisData =
                JSON.parse(laNodeOutputDataTmp);
              const gridNodeId = parseInt(
                loadingAnalysisOutputData.gridElementId
              );

              let gridElementName: string = "";
              const gridElement: GridElement = this.nodesMap.get(
                gridNodeId
              ) as GridElement;
              if (gridElement) {
                gridElementName = gridElement.getPropertyValue("name");
              }
              xAxisCategories.push(gridElementName);

              avgLoadSeries.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisOutputData.avgLoadPercent,
                    2
                  )
                )
              );
              maxLoadSeries.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisOutputData.maxLoadPercent,
                    2
                  )
                )
              );
              numberOfViolationsSeries.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisOutputData.numberOfViolations,
                    2
                  )
                )
              );
              numberOfViolationsSeries.yAxis = 1;
            });

            series.push(avgLoadSeries);
            series.push(maxLoadSeries);
            series.push(numberOfViolationsSeries);
          }

          console.log(JSON.stringify(series));
          (this.feederViewNodesOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
          this.feederViewNodesOptions.series = JSON.parse(
            JSON.stringify(series)
          );

          if (this.feederViewNodesChart) {
            this.feederViewNodesChart.options = this.feederViewNodesOptions;
          }
        });
      });
    }
    //if user has not selected scenario
    else {
      this.applicationService
        .getLANodesDataFeederView(gridElementIds)
        .subscribe((laNodeOutputDatas: Array<string>) => {
          console.log(laNodeOutputDatas);

          if (laNodeOutputDatas == null || laNodeOutputDatas.length == 0) {

            return;
          }

          const tooltipAvgLoad: any = Config.getChartTooltip("%");
          const avgLoadSeries: Series = new Series(
            this.labelAverageLoad,
            new Array<number>()
          );
          avgLoadSeries.tooltip = tooltipAvgLoad;
          avgLoadSeries.color = "#C0FE76";

          const tooltipMaxLoad: any = Config.getChartTooltip("%");
          const maxLoadSeries: Series = new Series(
            this.labelMaxLoad,
            new Array<number>()
          );
          maxLoadSeries.tooltip = tooltipMaxLoad;
          maxLoadSeries.color = "#85D9FF";

          const numberOfViolationsSeries: Series = new Series(
            this.labelViolations,
            new Array<number>()
          );
          numberOfViolationsSeries.tooltip = Config.getChartTooltip("");
          numberOfViolationsSeries.color = "#F54D65";

          const laOutputData: LoadingAnalysisData = JSON.parse(
            laNodeOutputDatas[0]
          );
          this.feederViewNodesOptions.yAxis[0].plotLines[0].value =
            laOutputData.nodeViolationLimitPercent;
          const xAxisCategories: Array<string> = new Array<string>();
          const series: Array<Series> = new Array<Series>();
          laNodeOutputDatas.forEach((laNodeOutputDataTmp: any) => {
            const loadingAnalysisOutputData: LoadingAnalysisData =
              JSON.parse(laNodeOutputDataTmp);
            const gridNodeId = parseInt(
              loadingAnalysisOutputData.gridElementId
            );

            let gridElementName: string = "";
            const gridElement: GridElement = this.nodesMap.get(
              gridNodeId
            ) as GridElement;
            if (gridElement) {
              gridElementName = gridElement.getPropertyValue("name");
            }
            xAxisCategories.push(gridElementName);

            avgLoadSeries.data.push(
              parseFloat(
                NumberUtils.format1(
                  loadingAnalysisOutputData.avgLoadPercent,
                  2
                )
              )
            );
            maxLoadSeries.data.push(
              parseFloat(
                NumberUtils.format1(
                  loadingAnalysisOutputData.maxLoadPercent,
                  2
                )
              )
            );
            numberOfViolationsSeries.data.push(
              parseFloat(
                NumberUtils.format1(
                  loadingAnalysisOutputData.numberOfViolations,
                  2
                )
              )
            );
            numberOfViolationsSeries.yAxis = 1;
          });

          series.push(avgLoadSeries);
          series.push(maxLoadSeries);
          series.push(numberOfViolationsSeries);

          console.log(JSON.stringify(series));

          (this.feederViewNodesOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
          this.feederViewNodesOptions.series = JSON.parse(
            JSON.stringify(series)
          );

          if (this.feederViewNodesChart) {
            this.feederViewNodesChart.options = this.feederViewNodesOptions;
          }

          
          this.updateFeederViewNodesChartFlag = true;
        });
    }
    
  }


  loadFeederViewNodesWorstCase() {

    clearInterval(this.intervalVariable)

    if (this.gridElementIdNodes) {
      this.feederViewNodesWorstCase(this.gridElementIdNodes);
    } else {
      this.applicationService
        .getFeederNodes(this.gridElementId)
        .subscribe((gridElements: Array<any>) => {
          console.log(gridElements);
          const gridElementIds: Array<number> = new Array<number>();
          gridElements.forEach((gridElement: any) => {
            gridElementIds.push(gridElement.id);
          });
          this.feederViewNodesWorstCase(gridElementIds);
        });
    }
  }
  private feederViewNodesWorstCase(gridElementIds: Array<number>) {
    //if user has selected scenario
    if (this.selectedPlanningScenario == true) {

      this.applicationService.getLANodesDataFeederViewPlanning(this.selectedScenario.id, gridElementIds).subscribe((laNodeOutputDatas: Array<string>) => {
        console.log(laNodeOutputDatas);

        this.applicationService.getLANodesDataFeederViewByScenarioId(gridElementIds, this.selectedScenarioId).subscribe((laNodeOutputDatasPlanning: Array<string>) => {
          console.log(laNodeOutputDatasPlanning)
          const xAxisCategories: Array<string> = new Array<string>();
          const series: Array<Series> = new Array<Series>();


          //////////////////////////////Feeder View Planning Series//////////////////////////////
          if (laNodeOutputDatasPlanning && laNodeOutputDatasPlanning.length > 0) {
            const tooltipMaxLoadPlanning: any = Config.getChartTooltip("%");
            const maxLoadSeriesPlanning: Series = new Series(
              this.labelLoadWorstCase,
              new Array<number>()
            );
            maxLoadSeriesPlanning.tooltip = tooltipMaxLoadPlanning;
            maxLoadSeriesPlanning.color = "#FF1600";

            const numberOfViolationsSeriesPlanning: Series = new Series(
              this.labelViolationsPlanning,
              new Array<number>()
            );
            numberOfViolationsSeriesPlanning.tooltip = Config.getChartTooltip("");
            numberOfViolationsSeriesPlanning.color = "#690101";


            if (xAxisCategories.length == 0) {

              laNodeOutputDatasPlanning.forEach((laNodeOutputDataTmp: any) => {

                const loadingAnalysisOutputData: LoadingAnalysisData = JSON.parse(laNodeOutputDataTmp);
                const gridNodeId = parseInt(loadingAnalysisOutputData.gridElementId);
                let gridElementName: string = "";
                const gridElement: GridElement = this.nodesMap.get(gridNodeId) as GridElement;
                if (gridElement) {
                  gridElementName = gridElement.getPropertyValue("name");
                }
                xAxisCategories.push(gridElementName);
              });
            }

            laNodeOutputDatasPlanning.forEach((laNodeOutputDataTmpPlanning: any) => {
              const loadingAnalysisOutputDataPlanning: LoadingAnalysisData =
                JSON.parse(laNodeOutputDataTmpPlanning);

              maxLoadSeriesPlanning.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisOutputDataPlanning.maxLoadPercent,
                    2
                  )
                )
              );

              numberOfViolationsSeriesPlanning.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisOutputDataPlanning.numberOfViolations,
                    2
                  )
                )
              );
              numberOfViolationsSeriesPlanning.yAxis = 1;

              this.feederViewNodesOptions.yAxis[0].plotLines[0].value = loadingAnalysisOutputDataPlanning.nodeViolationLimitPercent;
            });

            series.push(maxLoadSeriesPlanning);

            //series.push(numberOfViolationsSeriesPlanning);
          }
          ///////////////////////////////////////////////////////////////////////////////////////////

          if (laNodeOutputDatas && laNodeOutputDatas.length > 0) {

            const tooltipMaxLoad: any = Config.getChartTooltip("%");
            const maxLoadSeries: Series = new Series(
              this.labelMaxLoad,
              new Array<number>()
            );
            maxLoadSeries.tooltip = tooltipMaxLoad;
            maxLoadSeries.color = "#FF6600";

            const numberOfViolationsSeries: Series = new Series(
              this.labelViolations,
              new Array<number>()
            );
            numberOfViolationsSeries.tooltip = Config.getChartTooltip("");
            numberOfViolationsSeries.color = "#c90000";

            const laOutputData: LoadingAnalysisData = JSON.parse(
              laNodeOutputDatas[0]
            );
            this.feederViewNodesOptions.yAxis[0].plotLines[0].value =
              laOutputData.nodeViolationLimitPercent;

            if (xAxisCategories.length == 0) {

              laNodeOutputDatas.forEach((laNodeOutputDataTmp: any) => {

                const loadingAnalysisOutputData: LoadingAnalysisData = JSON.parse(laNodeOutputDataTmp);
                const gridNodeId = parseInt(loadingAnalysisOutputData.gridElementId);
                let gridElementName: string = "";
                const gridElement: GridElement = this.nodesMap.get(gridNodeId) as GridElement;
                if (gridElement) {
                  gridElementName = gridElement.getPropertyValue("name");
                }
                xAxisCategories.push(gridElementName);
              });

            }

            laNodeOutputDatas.forEach((laNodeOutputDataTmp: any) => {
              const loadingAnalysisOutputData: LoadingAnalysisData = JSON.parse(laNodeOutputDataTmp);

              maxLoadSeries.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisOutputData.maxLoadPercent,
                    2
                  )
                )
              );
              numberOfViolationsSeries.data.push(
                parseFloat(
                  NumberUtils.format1(
                    loadingAnalysisOutputData.numberOfViolations,
                    2
                  )
                )
              );
              numberOfViolationsSeries.yAxis = 1;
            });

            series.push(maxLoadSeries);
            //series.push(numberOfViolationsSeries);
          }

          console.log(JSON.stringify(series));
          (this.feederViewNodesOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
          this.feederViewNodesOptions.series = JSON.parse(
            JSON.stringify(series)
          );

          if (this.feederViewNodesChart) {
            this.feederViewNodesChart.options = this.feederViewNodesOptions;
          }
        });
      });
    }
    //if user has not selected scenario
    //TODO it is possible remove this else statement becouse in worst case the user always selected scenario
    else {
      this.applicationService.getLANodesDataFeederView(gridElementIds).subscribe((laNodeOutputDatas: Array<string>) => {
        console.log(laNodeOutputDatas);
        if (laNodeOutputDatas == null || laNodeOutputDatas.length == 0) {
          return;
        }
        const tooltipMaxLoad: any = Config.getChartTooltip("%");
        const maxLoadSeries: Series = new Series(
          this.labelMaxLoad,
          new Array<number>()
        );
        maxLoadSeries.tooltip = tooltipMaxLoad;
        maxLoadSeries.color = "#FF6600";

        const numberOfViolationsSeries: Series = new Series(
          this.labelViolations,
          new Array<number>()
        );
        numberOfViolationsSeries.tooltip = Config.getChartTooltip("");
        numberOfViolationsSeries.color = "#c90000";

        const laOutputData: LoadingAnalysisData = JSON.parse(
          laNodeOutputDatas[0]
        );
        this.feederViewNodesOptions.yAxis[0].plotLines[0].value =
          laOutputData.nodeViolationLimitPercent;
        const xAxisCategories: Array<string> = new Array<string>();
        const series: Array<Series> = new Array<Series>();
        laNodeOutputDatas.forEach((laNodeOutputDataTmp: any) => {
          const loadingAnalysisOutputData: LoadingAnalysisData =
            JSON.parse(laNodeOutputDataTmp);
          const gridNodeId = parseInt(
            loadingAnalysisOutputData.gridElementId
          );

          let gridElementName: string = "";
          const gridElement: GridElement = this.nodesMap.get(
            gridNodeId
          ) as GridElement;
          if (gridElement) {
            gridElementName = gridElement.getPropertyValue("name");
          }
          xAxisCategories.push(gridElementName);


          maxLoadSeries.data.push(
            parseFloat(
              NumberUtils.format1(
                loadingAnalysisOutputData.maxLoadPercent,
                2
              )
            )
          );
          numberOfViolationsSeries.data.push(
            parseFloat(
              NumberUtils.format1(
                loadingAnalysisOutputData.numberOfViolations,
                2
              )
            )
          );
          numberOfViolationsSeries.yAxis = 1;
        });

        series.push(maxLoadSeries);
        //series.push(numberOfViolationsSeries);

        console.log(JSON.stringify(series));

        (this.feederViewNodesOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
        this.feederViewNodesOptions.series = JSON.parse(
          JSON.stringify(series)
        );
        if (this.feederViewNodesChart) {
          this.feederViewNodesChart.options = this.feederViewNodesOptions;
        }
      });
    }
  }


  loadRpaFeederView() {

    clearInterval(this.intervalVariable)

    if (this.gridElementIdNodes) {
      this.feederRpaViewNodes(this.gridElementIdNodes);
    } else {
      this.applicationService
        .getFeederNodes(this.gridElementId)
        .subscribe((gridElements: Array<any>) => {
          console.log(gridElements);
          const gridElementIds: Array<number> = new Array<number>();
          gridElements.forEach((gridElement: any) => {
            gridElementIds.push(gridElement.id);
          });
          this.feederRpaViewNodes(gridElementIds);
        });
    }
  }

  // private feederRpaViewNodes(gridElementIds: Array<number>) {
  //   this.applicationService
  //     .getRPADataFeederView(gridElementIds)
  //     .subscribe((rpaNodeOutputDatas: Array<string>) => {
  //       console.log(rpaNodeOutputDatas);
  //       if (rpaNodeOutputDatas == null || rpaNodeOutputDatas.length == 0) {

  //         return;
  //       }

  //       const tooltipInductiveViolations: any = Config.getChartTooltip("");
  //       const inductiveViolations: Series = new Series(
  //         this.labelInductiveViolations,
  //         new Array<number>()
  //       );
  //       inductiveViolations.tooltip = tooltipInductiveViolations;

  //       const tooltipCapacityViolations: any = Config.getChartTooltip("");
  //       const capacityViolations: Series = new Series(
  //         this.labelCapacitiveViolations,
  //         new Array<number>()
  //       );
  //       capacityViolations.tooltip = tooltipCapacityViolations;

  //       const xAxisCategories: Array<string> = new Array<string>();
  //       const series: Array<Series> = new Array<Series>();

  //       rpaNodeOutputDatas.forEach((rpaNodeOutputDataTmp: any) => {

  //         let rpvResults: ReactivePowerAnalysis;
  //         rpvResults = JSON.parse(rpaNodeOutputDataTmp);
  //         const rpaViolationResultDtoLists: Map<string, ViolationResults> =
  //           rpvResults.rpaViolationResultDtoList;
  //         const violationsValue = new Map(
  //           Object.entries(rpaViolationResultDtoLists)
  //         ).get("1.0");

  //         const gridNodeId = parseInt(
  //           rpvResults.gridElementId
  //         );


  //         let gridElementName: string = "";
  //         const gridElement: GridElement = this.nodesMap.get(
  //           gridNodeId
  //         ) as GridElement;
  //         if (gridElement) {
  //           gridElementName = gridElement.getPropertyValue("name");
  //         }

  //         xAxisCategories.push(gridElementName);

  //         inductiveViolations.data.push(violationsValue.inductiveViolations_number)
  //         capacityViolations.data.push(violationsValue.capacitiveViolations_number);

  //       });

  //       series.push(inductiveViolations);
  //       series.push(capacityViolations);
  //       console.log(JSON.stringify(series));


  //       (this.feederViewRpaOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
  //       this.feederViewRpaOptions.series = JSON.parse(
  //         JSON.stringify(series)
  //       );

  //       if (this.feederViewRpaChart) {
  //         this.feederViewRpaChart.options = this.feederViewRpaOptions;
  //       }

  //     });

  // }

  private feederRpaViewNodes(gridElementIds: Array<number>) {
    this.applicationService
      .getRPADataFeederView(gridElementIds)
      .subscribe((rpaNodeOutputDatas: Array<string>) => {
        console.log(rpaNodeOutputDatas);
        if (rpaNodeOutputDatas == null || rpaNodeOutputDatas.length == 0) {

          return;
        }

        const tooltipInductiveViolations: any = Config.getChartTooltip("");
        const inductiveViolations: Series = new Series(
          this.labelInductiveViolations,
          new Array<number>()
        );
        inductiveViolations.tooltip = tooltipInductiveViolations;

        const tooltipCapacityViolations: any = Config.getChartTooltip("");
        const capacityViolations: Series = new Series(
          this.labelCapacitiveViolations,
          new Array<number>()
        );
        capacityViolations.tooltip = tooltipCapacityViolations;

        const xAxisCategories: Array<string> = new Array<string>();
        const series: Array<Series> = new Array<Series>();

        rpaNodeOutputDatas.forEach((rpaNodeOutputDataTmp: any) => {

          let rpvResults: ReactivePowerAnalysis;
          rpvResults = JSON.parse(rpaNodeOutputDataTmp);
          const rpaViolationResultDtoLists: Map<string, ViolationResults> =
            rpvResults.rpaViolationResultDtoList;
          const violationsValue = new Map(
            Object.entries(rpaViolationResultDtoLists)
          ).get("1.0");

          const gridNodeId = parseInt(
            rpvResults.gridElementId
          );


          let gridElementName: string = "";
          const gridElement: GridElement = this.nodesMap.get(
            gridNodeId
          ) as GridElement;
          if (gridElement) {
            gridElementName = gridElement.getPropertyValue("name");
          }

          xAxisCategories.push(gridElementName);

          inductiveViolations.data.push(violationsValue.inductiveViolations_number)
          capacityViolations.data.push(violationsValue.capacitiveViolations_number);

        });

        series.push(inductiveViolations);
        series.push(capacityViolations);
        console.log(JSON.stringify(series));


        (this.feederViewRpaOptions.xAxis as Highcharts.XAxisOptions).categories = xAxisCategories;
        this.feederViewRpaOptions.series = JSON.parse(
          JSON.stringify(series)
        );

        if (this.feederViewRpaChart) {
          this.feederViewRpaChart.options = this.feederViewRpaOptions;
        }

        
        this.updateFeederViewRpaChartFlag = true;

      });


  }

  /*doGPlanRunning() {
    let running: boolean = false;
    const currentTabStr: string = localStorage.getItem("currentTab");
    if (isNotNullOrUndefined(currentTabStr)) {
      if (currentTabStr == "gplan") {
        running = true;
      }
    }
    return running;
  }*/


  getCableTabColor() {
    let cableColor = new CableColor(+this.gridElementId);;

    const conditionFeederTrafoLoads: Array<Condition> = new Array<Condition>();
    const conditionFeederTrafoLoadsGP: Array<Condition> = new Array<Condition>();
    const conditionArrayGMon: Array<Condition> = new Array<Condition>();
    const conditionArrayGMonGP: Array<Condition> = new Array<Condition>();
    const conditionArrayRPA: Array<Condition> = new Array<Condition>();
    const colorArray: Array<string> = new Array<string>();
    const gridColorAppsJson: string = localStorage.getItem("gridColorApps");
    const cableColorAppsJson: string = localStorage.getItem("cableColorApps");


    // Color Condition Array for Nodes (GMon voltage -> voltage)
    if (gridColorAppsJson && this.gmonDataAvailable) {
      const gridColorApps: Array<GridColor> = JSON.parse(gridColorAppsJson);
      for (const gc of gridColorApps) {
        if (this.gridElementIdNodes.indexOf(gc.gridElementId) != -1) {
          conditionArrayGMon.push(gc.voltage);
        }
      }
      console.log('conditionArrayGMon:  ' + JSON.stringify(conditionArrayGMon));
    }

    // Color Condition Array for Nodes (GP/GMon voltage -> voltageGP)
    if (gridColorAppsJson && this.gplanDataAvailable) {
      const gridColorApps: Array<GridColor> = JSON.parse(gridColorAppsJson);
      for (const gc of gridColorApps) {
        if (this.gridElementIdNodes.indexOf(gc.gridElementId) != -1) {
          conditionArrayGMonGP.push(gc.voltageGP);
        }
      }
      console.log('conditionArrayGMonGP:  ' + JSON.stringify(conditionArrayGMonGP));
    }

    // Color Condition Array for Nodes (RPA -> rpa)
    if (gridColorAppsJson && this.rpaDataAvailable) {
      const gridColorApps: Array<GridColor> = JSON.parse(gridColorAppsJson);
      for (const gc of gridColorApps) {
        if (this.gridElementIdNodes.indexOf(gc.gridElementId) != -1) {
          conditionArrayRPA.push(gc.rpa);
        }
      }
      console.log('conditionArrayRPA:  ' + JSON.stringify(conditionArrayRPA));
    }


    // Color Condition Array for Cables (LA -> la)
    if (cableColorAppsJson && this.laDataAvailable) {
      const cableColorApps: Array<CableColor> = JSON.parse(cableColorAppsJson);
      for (const cc of cableColorApps) {
        if (+cc.gridElementId == +this.gridElementId) {
          //cableColor = new CableColor(+this.gridElementId);
          cableColor.la = cc.la;
        }
        if (this.gridElementIdcables.indexOf(cc.gridElementId) != -1) {
          colorArray.push(cc.la);
        }
      }
      console.log('colorArray:  ' + JSON.stringify(colorArray));
    }

    // Color Condition Array for Cables (GPLAN/LA -> laGP)
    if (cableColorAppsJson && this.gplanDataAvailable) {
      const cableColorApps: Array<CableColor> = JSON.parse(cableColorAppsJson);
      for (const cc of cableColorApps) {
        if (+cc.gridElementId == +this.gridElementId) {
          //cableColor = new CableColor(+this.gridElementId);
          cableColor.laGP = cc.laGP;
        }
        if (this.gridElementIdcables.indexOf(cc.gridElementId) != -1) {
          colorArray.push(cc.laGP);
        }
      }
      console.log('colorArray GP:  ' + JSON.stringify(colorArray));
    }

    // Color Condition Array for Nodes (LA -> la)
    if (gridColorAppsJson && this.laDataAvailable) {
      const gridColorApps: Array<GridColor> = JSON.parse(gridColorAppsJson);
      for (const gc of gridColorApps) {
        if (this.gridElementIdNodes.indexOf(gc.gridElementId) != -1) {
          conditionFeederTrafoLoads.push(gc.la);
        }
      }
      console.log('conditionFeederTrafoLoads:  ' + JSON.stringify(conditionFeederTrafoLoads));
    }

    // Color Condition Array for Nodes (LA(GPLAN) -> laGP)
    if (gridColorAppsJson && this.gplanAvailable) {
      const gridColorApps: Array<GridColor> = JSON.parse(gridColorAppsJson);
      for (const gc of gridColorApps) {
        if (this.gridElementIdNodes.indexOf(gc.gridElementId) != -1) {
          conditionFeederTrafoLoadsGP.push(gc.laGP);
        }
      }
      console.log('conditionFeederTrafoLoadsGP:  ' + JSON.stringify(conditionFeederTrafoLoadsGP));
    }

    this.setColorParameter(
      colorArray,
      conditionArrayRPA,
      conditionArrayGMon,
      conditionArrayGMonGP,
      cableColor,
      conditionFeederTrafoLoads,
      conditionFeederTrafoLoadsGP
    );
  }

  private setColorParameter(
    colorArray: Array<string>,
    conditionArrayRPA: Array<Condition>,
    conditionArrayGMon: Array<Condition>,
    conditionArrayGMonGP: Array<Condition>,
    cableColor: CableColor,
    conditionFeederTrafoLoads: Array<Condition>,
    conditionFeederTrafoLoadsGP: Array<Condition>) {

    // for "Cable Loading" Tab
    if (this.laDataAvailable && cableColor) {
      this.isDangerLACable = false;
      this.isAttentionLACable = false;
      if (cableColor.la == Config.CONDITION_COLOR_ATTENTION) {
        this.isAttentionLACable = true;
      } else if (cableColor.la == Config.CONDITION_COLOR_PROBLEM) {
        this.isDangerLACable = true;
      }
      console.log("cableColor.la: ") + cableColor.la;
    }

    // for "Cable Plan Loading" Tab
    if (this.gplanDataAvailable && cableColor) {
      this.isDangerLACableGP = false;
      this.isAttentionLACableGP = false;
      if (cableColor.laGP == Config.CONDITION_COLOR_ATTENTION) {
        this.isAttentionLACableGP = true;
      } else if (cableColor.laGP == Config.CONDITION_COLOR_PROBLEM) {
        this.isDangerLACableGP = true;
      }
      console.log("cableColor.laGP: ") + cableColor.laGP;
    }

    // for "Feeder Voltage" tab
    if (this.gmonDataAvailable && conditionArrayGMon.length > 0) {
      this.isDangerFeederGMon = false;
      this.isAttentionFeederGMon = false;
      const condition: Condition = GridColor.getHighestConditionInArray(conditionArrayGMon);
      console.log('hightest conditionArrayGMon:  ' + JSON.stringify(condition));
      if (condition == Condition.ATTENTION) {
        this.isAttentionFeederGMon = true;
      } else if (condition == Condition.PROBLEM) {
        this.isDangerFeederGMon = true;
      }
    }

    // for "Feeder Voltage - For Planning" tab
    if (this.gplanDataAvailable && conditionArrayGMonGP.length > 0) {
      this.isDangerFeederGMonGP = false;
      this.isAttentionFeederGMonGP = false;
      const condition: Condition = GridColor.getHighestConditionInArray(conditionArrayGMonGP);
      console.log('hightest conditionArrayGMonGP:  ' + JSON.stringify(condition));
      if (condition == Condition.ATTENTION) {
        this.isAttentionFeederGMonGP = true;
      } else if (condition == Condition.PROBLEM) {
        this.isDangerFeederGMonGP = true;
      }
    }

    //for "Feeder Cable Loads" tab
    if (this.laDataAvailable && colorArray.length > 0) {
      this.isDangerFeederLACable = false;
      this.isAttentionFeederLACable = false;
      const color: string = CableColor.getHighestColorInArray(colorArray);
      console.log('hightest colorArray:  ' + JSON.stringify(color));
      if (color == Config.CONDITION_COLOR_ATTENTION) {
        this.isAttentionFeederLACable = true;
      } else if (color == Config.CONDITION_COLOR_PROBLEM) {
        this.isDangerFeederLACable = true;
      }
    }

    //"Feeder Trafo Loads" tab
    if (this.laDataAvailable && conditionFeederTrafoLoads) {
      this.isDangerFeederTrafoLoads = false;
      this.isAttentionFeederTrafoLoads = false;
      const condition: Condition = GridColor.getHighestConditionInArray(conditionFeederTrafoLoads);
      console.log('hightest conditionFeederTrafoLoads:  ' + JSON.stringify(condition));
      if (condition == Condition.ATTENTION) {
        this.isAttentionFeederTrafoLoads = true;
      } else if (condition == Condition.PROBLEM) {
        this.isDangerFeederTrafoLoads = true;
      }
    }

    //"Feeder Trafo Loads - for planning" tab
    if (this.gplanDataAvailable && conditionFeederTrafoLoadsGP) {
      this.isDangerFeederTrafoLoadsGP = false;
      this.isAttentionFeederTrafoLoadsGP = false;
      const condition: Condition = GridColor.getHighestConditionInArray(conditionFeederTrafoLoadsGP);
      console.log('hightest conditionFeederTrafoLoadsGP:  ' + JSON.stringify(condition));
      if (condition == Condition.ATTENTION) {
        this.isAttentionFeederTrafoLoadsGP = true;
      } else if (condition == Condition.PROBLEM) {
        this.isDangerFeederTrafoLoadsGP = true;
      }
      //  console.log(this.gridElementId + ', gmon-condition: ' + gridColor.gmon);
    }

    //for "Feeder RPA" tab
    if (this.rpaDataAvailable && conditionArrayRPA.length > 0) {
      this.isDangerFeederRPANode = false;
      this.isAttentionFeederRPANode = false;
      const condition: Condition = GridColor.getHighestConditionInArray(conditionArrayRPA);
      console.log('hightest conditionArrayRPA:  ' + JSON.stringify(condition));
      if (condition == Condition.ATTENTION) {
        this.isAttentionFeederRPANode = true;
      } else if (condition == Condition.PROBLEM) {
        this.isDangerFeederRPANode = true;
      }
    }

    /*
    if (this.laDataAvailable && conditionArrayLA.length > 0) {
      this.isDangerFeederGMon = false;
      this.isAttentionFeederGMon = false;
      const condition: Condition = GridColor.getHighestConditionInArray(conditionArrayLA);
      console.log('condition:  ' + JSON.stringify(condition));
      if (condition == Condition.ATTENTION) {
        this.isAttentionFeederLANode = true;
      } else if (condition == Condition.PROBLEM) {
        this.isDangerFeederLANode = true;
      }
    }
    */

  }

  private initDataAvailableParameters() {
    this.gmonDataAvailable = this.gMonService.areDataAvailable("areVoltageDataAvailable");
    this.laDataAvailable = this.laService.areLADataAvailable();
    this.gplanDataAvailable = this.gPlanService.areGplanDataAvailable();
    this.rpaDataAvailable = this.rpaService.areRPADataAvailable();
  }

  getGridElementIdNodes() {
    this.applicationService.getFeederNodes(this.gridElementId).subscribe((gridElements: Array<any>) => {
      console.log(JSON.stringify(gridElements));
      gridElements.forEach((gridElement: any) => {
        this.gridElementIdNodes.push(gridElement.id);
      });
      // console.log(JSON.stringify(this.gridElementIdNodes));
      if (this.laAvailable && this.laDataAvailable) {
        this.getGridElementIdCables();
      } else {
        this.getCableTabColor();
      }
    });
  }

  getGridElementIdCables() {
    this.applicationService
      .getFeederCables(this.gridElementId)
      .subscribe((cables: Array<any>) => {
        console.log(cables);
        cables.forEach((cable: any) => {
          this.gridElementIdcables.push(cable.GridElement.id);
        });
        // console.log(JSON.stringify(this.gridElementIdcables));
        this.getCableTabColor();
      });
  }
  checkWorstCase() {

    if (this.selectedPlanningScenario && this.selectedScenario.type == "WC") {
      this.worstCase = true
    }
    else {
      this.worstCase = false
    }

    return this.worstCase
  }

  form = new FormGroup({
    userHoursInput: new FormControl('')
  });

  submitButtonLiveCableLoad(){
    this.applicationService.getLiveCablePowerLoad(this.gridElementId, this.lmResultVisualizationInterval).subscribe((response => {
      this.timestampArray.length = 0;
      this.livePowerView(response);
    }))
  }

  loadLiveCableLoad(){
    this.applicationService.getLiveCablePowerLoad(this.gridElementId, this.lmResultVisualizationInterval).subscribe((firstResponse) => {
      console.log("First Live Cable Load call is performed: ", firstResponse);
      this.livePowerView(firstResponse);
    }, error => {
      console.error("Error occured, failed to perorm the first call for Live Cable Load: ", error)
    })
    clearInterval(this.intervalVariable);
    this.intervalVariable = setInterval(() => {
      this.applicationService.getLiveCablePowerLoad(this.gridElementId, this.lmResultVisualizationInterval).subscribe(
        (response) => {
          console.log("API response for Live Cable Power Load: ", response);
          this.livePowerView(response);
        },
        error => {
          console.error("Error occured, whiel performing call for the Live Cable Power Load", error)
        }
      )
    }, 1000 * this.lmResultsRefreshPeriodInSeconds);
  }


  public livePowerView(livePowerDataResponse: any){

    var timestamp: any;
    var activeLivePower: any;
    var reactiveLivePower: any;
    var value: any;

    livePowerDataResponse.reverse();

    livePowerDataResponse.forEach(element => {
      console.log(`Timestamp: ${element.timestamp}, Value: ${element.timestamp}`)

      timestamp = element.timestamp;
      activeLivePower = element.activePower_kW;
      reactiveLivePower = element.reactivePower_kVar;
      value = element.value;

      if(this.timestampArray.slice(-1) != timestamp){
        this.settingIntervalForChart();
      }

      var justDifferenceInMinutes;

      if(this.timestampArray.length != 0){
        if(DateUtils.stringUTCDateToLocalDateObject(this.timestampArray[this.timestampArray.length-1]).getTime() - DateUtils.stringUTCDateToLocalDateObject(timestamp).getTime() != -60000){
          var lastWrongElementsFromTimestampArray = this.timestampArray[this.timestampArray.length-1]
          var timestampArrayTentative: Array<any> = new Array<any>();
          for(var i = 1; i < (DateUtils.stringUTCDateToLocalDateObject(timestamp).getTime() - DateUtils.stringUTCDateToLocalDateObject(this.timestampArray[this.timestampArray.length-1]).getTime()) / 60000; i++){
            justDifferenceInMinutes = DateUtils.stringUTCDateToLocalDateObject(this.timestampArray[this.timestampArray.length - 1]).getMinutes();
            // console.log(lastWrongElementsFromTimestampArray)
            console.log(DateUtils.stringUTCDateToLocalDateObject(lastWrongElementsFromTimestampArray).getMinutes() + i)

            console.log(DateUtils.dateToString3(new Date(new Date(lastWrongElementsFromTimestampArray).setMinutes(justDifferenceInMinutes + i))));
            timestampArrayTentative.push(DateUtils.dateToString3(new Date(new Date(lastWrongElementsFromTimestampArray).setMinutes(justDifferenceInMinutes + i))));

            if(!this.value.includes(undefined)){
              this.value.push(null);
            }
          }
          this.timestampArray.push.apply(this.timestampArray, timestampArrayTentative)
        }
      }

      if(!this.timestampArray.includes(timestamp)){
        this.timestampArray.push(timestamp);
        this.value.push(value);
      }else{
        console.log("Array already contains this information")
      }
    })

    console.log("TIMESTAMP " + timestamp + " timestamp array" + this.timestampArray.slice(-1) )

    if (this.livePowerDataOptions != undefined) {
      this.livePowerDataOptions.series[0].data = this.value;
      console.log("LIVE VALUE ARRAY " + this.value)
      this.livePowerDataOptions.xAxis.categories = this.timestampArray.map(timestamp => {
        if (timestamp && !isNaN(Date.parse(timestamp))) {
            return DateUtils.stringUTCDateToLocalDate(timestamp);
        }
        return null; // Return the original value if it is not valid
    });
      console.log("LIVE timestamps  " + this.timestampArray)
    }
  }

  isLMRunning(): boolean {
    let currentTopology = JSON.parse(localStorage.getItem("currentTopology"));
    return this.lmService.isLMRunning(currentTopology.topologyId);
  }

  isScccRunning(): boolean{
    return this.shortCircuitCurrentAnalysisService.getIsSccaAvailable();
  }

  getListOfScenarios(){
    this.gPlanService.getListAvailableScenarios().subscribe((scenarois: Array<GPlanInput>) => {
      if(scenarois){
        scenarois.forEach(scenario => {
          this.scenariosMap.set(scenario.id, scenario.name)
        })
      }
    })
  }

  loadSccaResults(){
    this.shortCircuitCurrentAnalysisService.getSccaResults(this.gridElementId).subscribe((scccOutputDatas: Array<string>) => {
      let xAxisCategoriesUpdated: string[] = [];
      let minISCArray: number[] = [];
      let maxISCArray: number[] = [];

      scccOutputDatas.forEach((scccOutputDataTmp: any) => {
        const scccOutputData: ScccData = scccOutputDataTmp;
        if(scccOutputData.gridPlanningScenarioId == null && !this.selectedPlanningScenario){
          xAxisCategoriesUpdated.push(`${this.translations["cabledetails"]["bc6fdc27-bb0b-4301-8b12-ba33497c68ef"]}`);
          minISCArray.push(JSON.parse(scccOutputData.shortCircuitCurrentDto).minISC);
          maxISCArray.push(JSON.parse(scccOutputData.shortCircuitCurrentDto).maxISC - JSON.parse(scccOutputData.shortCircuitCurrentDto).minISC);
        }
        else if(this.selectedPlanningScenario){
          if((scccOutputData.gridPlanningScenarioId == this.selectedScenario.id)){
            minISCArray.push(JSON.parse(scccOutputData.shortCircuitCurrentDto).minISC);
            maxISCArray.push(JSON.parse(scccOutputData.shortCircuitCurrentDto).maxISC - JSON.parse(scccOutputData.shortCircuitCurrentDto).minISC);
          }
          if((this.selectedScenario.id == scccOutputData.gridPlanningScenarioId)){
            if(scccOutputData.mode == 0){
              xAxisCategoriesUpdated.push(`${this.translations["cabledetails"]["68f45996-ee13-417b-9bda-05f76a3fe733"]} ${this.scenariosMap.get(scccOutputData.gridPlanningScenarioId)}`);
            }
            if(scccOutputData.mode == 1){
              xAxisCategoriesUpdated.push(`${this.translations["cabledetails"]["0065bd47-4d13-4e75-b8fb-1426828a4bed"]} ${this.scenariosMap.get(scccOutputData.gridPlanningScenarioId)}`);
            }
          }
        }

      })
      this.scccOutputViewOptions = {
        chart: {
          width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
          type: "column",
          zoomType: "xy",
          resetZoomButton: {
            position: {
              x: 0,
              y: -45
            }
          },
          styledMode: true,
        },
        title:{
          text: this.translations["short-circuit-current-calculations"]["1eeaa911-adb8-4190-916d-784654a631a3"],
        },
        xAxis: {
          labels:{
            enabled: true
          },
          categories: xAxisCategoriesUpdated,
          title: {
            text: "",
          }
        },
        yAxis: [
          {
            min: 0,
            // scaleBreaks:{
            //   autoCalculate: true,
            // },
            title: {
            text: this.translations["short-circuit-current-calculations"]["ecda9546-aa16-40dd-acf4-4bbd367907d6"],
            }
          },
          {
            opposite: true,
            allowDecimals: false,
            title: {
              text: "",
            },
          },
        ],
        legend: {
          enabled: true,
          layout: "horizontal",
          align: "center",
          itemStyle: {
cursor: "default"
          },
          itemHoverStyle: {
            cursor: "default"  // the cursor style will not change if the user hovers over the legend items
          },
          // useHTML: true,
          labelFormatter: function(){
            return this.name;
          }
        },
        plotOptions: {
          series: {
            stickyTracking: true,
      // whiskerWidth: 5,
            // This event prevents user from hiding one of the series by click on it from the legend
            events: {
              legendItemClick: function(){
                return false;
              }
            }
          },
          column:{
            stacking: 'normal'
          }
        },
        series: [
          {
            type: "column",
            name: this.translations["cabledetails"]["338e3931-5266-46b8-a2f2-efc351a8087a"],
            data: maxISCArray,
            color: "#cc0000",
          },
          {
            type: "column",
            name: this.translations["cabledetails"]["f89f57e1-ead6-4155-85bb-d8c4ee12df81"],
            data: minISCArray,
            color: "#008000",
          }
        ],
        tooltip: {
          useHTML: true,
          formatter: function () {
            // return Config.getChartTooltipScccChart(this)
            const point = this.point;
            const seriesName = this.series.name;
            // const yValue = this.y;
            const valueSuffix = "A"
            let valueTotal;

if (seriesName == "max ISC"){
              valueTotal = point.total;
            }else{
              valueTotal = point.y;
            }

            return `<div style = color: #333; background-color: #f9f9f9; padding:10px; border-radius: 5px;">
<strong>${seriesName}</strong><br>
                <span>Value: <strong>${valueTotal.toFixed(2)} ${valueSuffix}</strong></span>
              </div>`;
          }
        },
        credits: {
          enabled: false,
        },
      }
    })
  }

  ngOnDestroy(){
    clearInterval(this.intervalVariable)
  }

  copyToClipboard() {
    const textToCopy = `${this.cableSourceNode} --- ${this.cableEndNode}`;
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.snackBar.open('Cable copied to clipboard!', '', {
        duration: 3000,
        horizontalPosition: 'left',
        verticalPosition: 'bottom',
        panelClass: ['snackbar-success']
      });
    });
  }

  // Method to copy text to clipboard
  copyTextToClipboard(text: string): boolean {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    const successful = document.execCommand('copy');
    document.body.removeChild(textarea);
    return successful;
  }

    jumpToTopology(){
      let currentTopology = JSON.parse(localStorage.getItem("currentTopology"));
      this.activeModal.close();
      let prop = { "param": this.jumpTopology, "param2": currentTopology.topologyId }
      this.communicationService.triggerMethod(prop);
    }

}
